import { coerceNumberProperty } from '@angular/cdk/coercion';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { SelectItem } from 'primeng/api/selectitem';
import { UnitTreeNode } from '../../../masterscreen/model/unit-tree.model';
import { MasterscreenService } from '../../../masterscreen/services/masterscreen.service';
import { Login } from '../../../observation/model/login.model';
import { SearchText } from '../../../observation/model/searchTexts.model';
import { Usertypes } from '../../../observation/model/usertypes.model';
import { ObservationConstantsService } from '../../../observation/services/observation-constants.service';
import { ObservationService } from '../../../observation/services/observation.service';
import { RiskConstantsService } from '../../../risk/services/risk-constants.service';
import { SpecificationData } from '../../../shared/components/category/category.component';
import { FileAttachment } from '../../../shared/models/file-attachment.model';
import {
  User,
  UserLogInActivity,
  UserPermissionParameters,
} from '../../../shared/models/user.model';
import { BaseService } from '../../../shared/services/base.service';
import { CommonService } from '../../../shared/services/common.service';
import { HseErrorHandlerService } from '../../../shared/services/hse-error-handler.service';
import { NotificationsService } from '../../../shared/services/notification.service';
import { FileUtility } from '../../../shared/utility/file.utility';
import { CommunicationSource } from '../../model/communicationSource.model';
import { IncidentRating } from '../../model/incident-rating';
import { IncidentCategory } from '../../model/incidentCategory.model';
import { IncidentPermissionDetails } from '../../model/incidentpermissiondetails.model';
import {
  IncidentPearDetails,
  IncidentRequest,
} from '../../model/incidentRequest.model';
import {
  AssetsIncident,
  CaseOwnerAction,
  CaseOwnerIncidentAction,
  EnvironmentIncident,
  IncidentAction,
  IncidentActionDetails,
  IncidentProcess,
  IncidentRequestPost,
  NPTIncident,
  PearDetails,
  PeopleIncident,
  RaiseIncident,
  ReputationIncident,
  SubmitDraftReportAction,
  SubmitInvestigationAction,
  SubmitMOM,
  SubmitTorAction,
} from '../../model/incidentRequestPost.model';
import { IncidentType } from '../../model/incidentType.model';
import { PeopleInvolved } from '../../model/peopleInvolved.model';
import { SpilDetails } from '../../model/spilDetails.model';
import { IncidentConstantsService } from '../../services/incident-constants-service';
import { IncidentService } from '../../services/incident.service';
import { ConstantsService } from './../../../shared/services/constants.service';
import { PerformanceService } from '../../../performance-dashboard/services/performance.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'ara-raise-incident',
  templateUrl: './raise-incident.component.html',
  styleUrls: ['./raise-incident.component.css'],
})
export class RaiseIncidentComponent implements OnInit {
  selectedUserEmp: User;
  tempFiles: any[] = [];
  incidentId: number = 0;
  selectedGeneralManager: User;
  successDetails: string;
  loggedInUserJSON: any;
  searchTexts: SearchText;
  user: User;
  employee: User;
  company: any = {};
  locations: SelectItem[];
  incidentType: IncidentType[] = [];
  login: Login;
  people: PeopleInvolved;
  spilDetail: SpilDetails;
  spilDetails: SpilDetails[] = [];
  peopleInvolved: PeopleInvolved[] = [];
  userResults: User[] = [];
  userTypes: Usertypes[] = [];
  incidet: string;
  incidentRequest: IncidentRequest;
  incidentRequest1: IncidentRequest;
  communicationSource: CommunicationSource[] = [];
  errorDetails: any;
  incidentCategory: IncidentCategory[] = [];
  selectedincidentCategoryId: number[] = [];
  selectedincidentTypeId: string[] = [];
  alertType: string;
  sub: any;
  display: boolean = false;
  pearMaster = [];
  severityMaster = [];
  dateTime = new Date();
  validate: boolean = true;
  unitError: boolean;
  isIncidentReportErrorMsg: boolean = false;
  isIncidenttakingErrorMsg: boolean = false;
  isDisplay: boolean = false;
  isDisplayAdd: boolean = true;
  accept: string;
  isReportedviamsg: boolean = false;
  isIncidentDateErrorMsg: boolean = false;
  isLocationMsg: boolean = false;
  isInitialKnownMsg: boolean = false;
  isIncidentCategory: boolean = false;
  isShowpearErrorMsg: boolean = false;
  isSeverityErrorMsg: boolean = false;
  isClassificationErrorMsg: boolean = false;
  isOwnerErrorMsg: boolean = false;
  isActiontakenMsg: boolean = false;
  isCauseMsg: boolean = false;
  isIPStatusMsg: boolean = false;
  isInitialClassification: boolean = false;
  isemployeeErrorMsg: boolean = false;
  isJobErrorMsg: boolean = false;
  isInjuryErrorMsg: boolean = false;
  isEquipmentErrorMsg: boolean = false;
  istagErrorMsg: boolean = false;
  isIncidentType: boolean = false;
  routesFlag: { routeName: string; routeURL: string; isClickable: boolean }[];
  reportRoutes: { routeName: string; routeURL: string; isClickable: boolean }[];
  Button: any = {
    showResetButton: true,
  };
  isDisplaySpilldetails: boolean = false;
  multiple: boolean = false;
  PeopleIncident = new PeopleIncident();
  AssetsIncident = new AssetsIncident();
  EnvironmentIncident = new EnvironmentIncident();
  ReputationIncident = new ReputationIncident();
  NPTIncident = new NPTIncident();
  confirmMessage: string;
  ShowPeopleSeverityMessage: boolean = false;
  ShowEnvironmentSeverityMessage: boolean = false;
  ShowAssetsSeverityMessage: boolean = false;
  ShowReputationSeverityMessage: boolean = false;
  ShowNPTSeverityMessage: boolean = false;
  selectedLocation: number = 0;
  oldIncident: IncidentRequest;
  retVal: boolean;
  userActivityList: any[] = [];
  raised: boolean = false;
  potentialIncidentColor = '';
  consequenceMaster = [];
  raiseIncidentRequest: RaiseIncident = new RaiseIncident();
  isHighPotential: string;
  url: any;
  url1: any;
  FileUrl: any[] = [];
  incidentActionDetailsRequest: IncidentActionDetails[];
  actionPost: IncidentActionDetails;
  submitTORAction = new SubmitTorAction();
  submitDraftReportAction = new SubmitDraftReportAction();
  submitInvestigationAction = new SubmitInvestigationAction();
  showTor: boolean = false;
  showDraft: boolean = false;
  showInvestigation: boolean = false;
  caseOwnerIncidentAction: CaseOwnerIncidentAction;
  incidentRequestId: number;
  caseOwnerDetails: any[];
  caseOwnerActionId: number;
  torDate: Date = new Date();
  draftDate: Date;
  investigateDate: Date;
  disableAction: boolean;
  incidentActionById: any[] = [];
  closeIncident: boolean;
  incidentAction: IncidentAction;
  validateAction: boolean = true;
  showPotentialIncident: boolean = false;
  isUpdateAllowed: boolean = false;
  selectedReporting: string[] = [];
  showBackOffice: string;
  showPotentialSection: boolean;
  ratingdialog: boolean = false;
  caseOwnerAction: CaseOwnerAction[];
  showDeletionmsg: boolean = false;
  showCancellationmsg: boolean = false;
  caseOwner: CaseOwnerAction[] = [
    {
      Name: 'Submit TOR',
      FileUrl: [],
      DueDate: new Date(),
      Enabled: true,
      SelectedMarkAction: false,
      CaseOwnerActionId: 0,
    },
    {
      Name: 'Submit Draft Report',
      FileUrl: [],
      DueDate: new Date(),
      Enabled: true,
      SelectedMarkAction: false,
      CaseOwnerActionId: 0,
    },
    {
      Name: 'Submit Final Investigation Report',
      FileUrl: [],
      DueDate: new Date(),
      Enabled: true,
      SelectedMarkAction: false,
      CaseOwnerActionId: 0,
    },
  ];
  ResidualPeopleIncident = new PeopleIncident();
  ResidualAssetsIncident = new AssetsIncident();
  ResidualEnvironmentIncident = new EnvironmentIncident();
  ResidualReputationIncident = new ReputationIncident();
  ResidualNPTIncident = new NPTIncident();
  PotentialPeopleIncident = new PeopleIncident();
  PotentialAssetsIncident = new AssetsIncident();
  PotentialEnvironmentIncident = new EnvironmentIncident();
  PotentialReputationIncident = new ReputationIncident();
  PotentialNPTIncident = new NPTIncident();
  isBackOffice: boolean;
  incidentIdForCaseOwner: number;
  showPopUp: boolean;
  processName: any;
  processIndex: number;
  closureDetails = 'Incident Closed';
  isCaseOwner: boolean;
  warningMessage: string;
  isClosed: boolean;
  showCloseIncident: boolean;
  displayId: string;
  fileAttachments: any[] = [];
  showDeleteButton: boolean;
  elevatedPermission: boolean;
  showImage: boolean = false;
  selectedIndex: any;
  incidentFiles: any[];
  disablePotential: boolean = false;
  userPermissions: UserPermissionParameters;
  incidentPermission: IncidentPermissionDetails;
  disableIncident: boolean = false;
  unitList: any = [];
  selectedUnit: any;
  isReset: boolean;
  toolTip: string;
  assetsMaster = [];
  environmentMaster = [];
  reputationMaster = [];
  NPTMaster = [];
  tempUnits: string;
  incidentLoaded: boolean;
  incidentIds: any[];
  incidentIndex: number = -1;
  isNext: boolean = true;
  isPrevious: boolean = true;
  alertFrom: string = '';
  incidentProcess: IncidentProcess[] = [];
  currentDate: Date = new Date();
  isEnabled: boolean;
  momDate: Date;
  submitMom = new SubmitMOM();
  isShowDisabled: boolean = false;
  independentPermissions: any;
  investigationDetails: SelectItem[];
  selectedInvestigation: number = 0;
  moduleList: any[] = [];
  moduleId: number;
  sourceId: number;
  categoryCheckedValueData: any[] = [];
  specificationDetailsData: SpecificationData;
  unitTree: UnitTreeNode[];
  cancelActionId: number;
  cancelRecord: boolean = false;
  cancellationReason: any;
  deleteRecord: boolean;
  deleteActionId: any;
  deletionReason: any;
  disableSource: boolean = false;
  incidentRating: IncidentRating = new IncidentRating();
  ratings: SelectItem[] = [];
  reportedToList: any[] = [];
  reportingErrorMsg: boolean = false;
  incidentTypeErrorMsg: boolean = false;
  isDetailsDescriptionMsg: boolean;
  isShortDescriptionMsg: boolean;
  isCaseOwnerMsg: boolean;
  isActive: boolean = false;
  isInactiveLocation: boolean = false;

  ContractNumber: string = '';
  isEmployee: boolean = true;

  updateActionTrack: any[];
  locationDet: any;
  incidentDet: any;
  selctedIncType: any[];

  //BOC Pritesh
  dialogHeight: string;
  dialogWidth: string;
  ReportUserId: number;
  ReportModule: string;
  ReportRecordId: number;
  ReportProcessId: number = 0;
  ReportclosePopup: boolean = false;
  contracts: { label: string; value: string }[] = [];
  unitContractDetails: any[] = [];
  isHasContractDetails: boolean = true;
  selectedContract: number = 0;
  hideContract: boolean = true;
  showContractValidation: boolean = false;
  isUnitEmployee: boolean = true;
  editEnabled: boolean = true;
  IsNewRecord: boolean = true;
  //EOC Pritesh

  constructor(
    private observationService: ObservationService,
    private commonService: CommonService,
    private baseService: BaseService,
    private route: ActivatedRoute,
    private hseErrorHandler: HseErrorHandlerService,
    private router: Router,
    private incidentService: IncidentService,
    private masterscreenService: MasterscreenService,
    private notificationsService: NotificationsService,
    private PDService: PerformanceService,
    private translate: TranslateService,
  ) {
    this.searchTexts = new SearchText();
    this.dateTime.setDate(this.dateTime.getDate());
    this.incidentRequest = new IncidentRequest();
    this.incidentRequest.IncidentRequest = new IncidentRequestPost();
    this.user = new User();
    this.accept =
      '.jpg,.JPG,.jpeg,.JPEG,.png,.PNG,.bmp,.BMP,.pdf,.PDF,.docx,.DOCX,.xlsx,.XLSX,.doc,.DOC,.pptx,.PPTX,.ppt,.PPT,.heic,.HEIC,.heif,.HEIF,.xls,.XLS';
    this.multiple = true;
    this.login = new Login();
    this.incidentActionDetailsRequest = [];
    this.actionPost = new IncidentActionDetails();
    this.caseOwnerIncidentAction = new CaseOwnerIncidentAction();
    this.caseOwnerDetails = [];
    this.incidentAction = new IncidentAction();
    const newDueDateForST = new Date();
    this.incidentPermission = new IncidentPermissionDetails();
    this.specificationDetailsData = new SpecificationData();
    if (this.submitTORAction.Name === 'Submit TOR') {
      newDueDateForST.setDate(this.submitTORAction.DueDate.getDate() + 3);
      this.submitTORAction.DueDate = newDueDateForST;
      this.torDate = this.submitTORAction.DueDate;
    }
    const newDueDateForSDR = new Date();
    if (this.submitDraftReportAction.Name === 'Submit Draft Report') {
      newDueDateForSDR.setDate(
        this.submitDraftReportAction.DueDate.getDate() + 7,
      );
      this.submitDraftReportAction.DueDate = newDueDateForSDR;
      this.draftDate = this.submitDraftReportAction.DueDate;
    }
    const newDueDateForSFIR = new Date();
    if (
      this.submitInvestigationAction.Name ===
      'Submit Final Investigation Report'
    ) {
      newDueDateForSFIR.setDate(
        this.submitInvestigationAction.DueDate.getDate() + 30,
      );
      this.submitInvestigationAction.DueDate = newDueDateForSFIR;
      this.investigateDate = this.submitInvestigationAction.DueDate;
    }
    this.fileAttachments = [];
    this.incidentFiles = [];
    this.userPermissions = new UserPermissionParameters();
    this.incidentPermission = new IncidentPermissionDetails();
    this.selectedGeneralManager = new User();
    this.ratings.push({ label: 'Select', value: '-1' });
    this.ratings.push({ label: '0', value: '0' });
    this.ratings.push({ label: '1', value: '1' });
    this.ratings.push({ label: '2', value: '2' });
    this.ratings.push({ label: '3', value: '3' });
    this.reportedToList.push({
      label: 'Management',
      value: '0',
      checked: false,
    });
    this.reportedToList.push({ label: 'Client', value: '1', checked: false });
    this.reportedToList.push({
      label: 'Environmental Authority',
      value: '2',
      checked: false,
    });
    this.reportedToList.push({
      label: 'Ministry Of Manpower',
      value: '3',
      checked: false,
    });
    this.reportedToList.push({ label: 'ROP', value: '4', checked: false });
  }

  ngOnInit() {
    this.baseService.showRootLoader = true;
    this.independentPermissions = JSON.parse(
      this.baseService.getItemFromSession('UserIndependentPermissions'),
    );
    this.consequenceMaster = IncidentConstantsService.Consequence;
    this.communicationSource =
      IncidentConstantsService.CommunicationSource.CommunicationSource;
    this.pearMaster = RiskConstantsService.Pear;
    this.severityMaster = IncidentConstantsService.PeopleSeverity;
    this.environmentMaster = IncidentConstantsService.EnvironmentSeverity;
    this.assetsMaster = IncidentConstantsService.AssetsSeverity;
    this.reputationMaster = IncidentConstantsService.ReputationSeverity;
    this.NPTMaster = IncidentConstantsService.NPTSeverity;
    const loggedInUser = this.baseService.getItemFromSession('loggedInUser');

    this.loggedInUserJSON = JSON.parse(loggedInUser);
    const apiRequestUnit = {
      Model: {
        ModuleId: ConstantsService.PermissionMatrixModules.Incident,
        UserId: this.loggedInUserJSON.UserId,
        IsActive: this.IsNewRecord,
      },
    };
    this.masterscreenService.getUnits(
      apiRequestUnit,
      this.callbackMethodForUnitDetails.bind(this),
    );
    if (
      this.loggedInUserJSON.UserTypes.UserType ===
      ObservationConstantsService.RequestFor.Contractor
    ) {
      this.isEmployee = false;
      this.ContractNumber = this.loggedInUserJSON.ContractNumber;
    } else {
      this.isEmployee = true;
      this.ContractNumber = '';
    }

    this.routesFlag = IncidentConstantsService.IncidentNavigation.InnerRoutes;
    this.reportRoutes =
      IncidentConstantsService.IncidentNavigation.ReportRoutes;
    this.people = new PeopleInvolved();
    this.employee = new User();
    this.selectedUserEmp = new User();
    this.incidentRequest.IncidentRequest.IncidentObserveBy = new User();
    this.incidentRequest.IncidentRequest.CaseOwnerAppointment = new User();
    this.peopleInvolved.push(this.people);
    this.spilDetail = new SpilDetails();
    this.spilDetails.push(this.spilDetail);
    this.login.CompanyId = this.loggedInUserJSON.Company.CompanyId;
    this.login.ID = this.loggedInUserJSON.UserId;
    this.sub = this.route.params.subscribe((params) => {
      this.incidentId = coerceNumberProperty(params['incidentId']);
    });
    this.isHighPotential = 'false';
    this.selectedLocation = this.baseService.getItemFromSession(
      'IncidentLocation' + this.loggedInUserJSON.Company.CompanyName,
    );

    this.incidentService.getInvestigationDetails(
      null,
      this.callbackMethodForGetInvestigationDetails.bind(this),
    );
    const apiRequest = {
      Model: {
        GetAllProcess: false,
      },
    };
    this.incidentService.getIncidentProcessDetails(
      apiRequest,
      this.callbackMethodForGetIncidentProcessDetails.bind(this),
    );

    if (this.incidentId > 0) {
      this.IsNewRecord = false;
      this.isDisplay = true;
      this.isDisplayAdd = false;
    }
    this.commonService.getUserIndependentPermissions(
      this.loggedInUserJSON.UserId,
    );
    this.sourceId = this.incidentId;
    this.submitTORAction.Enabled = true;
    this.submitDraftReportAction.Enabled = false;
    this.submitInvestigationAction.Enabled = false;
    this.caseOwnerAction = [];
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });
    this.disableSource = false;
  }
  callbackMethodForUnitDetails(response) {
    if (response.Success) {
      this.unitList = response.Result;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          GetActiveNodes: this.IsNewRecord,
          UserId: this.loggedInUserJSON.UserId,
        },
      };
      this.masterscreenService.getTreeData(
        apiRequest,
        this.callbackMethodForGetTreeData.bind(this),
      );
    }
  }
  callbackMethodForGetTreeData(response) {
    if (response.Result !== null) {
      this.unitTree = response.Result;
      if (this.incidentId === 0) {
        this.unitTree.forEach((element) => {
          this.compareTreeNode(element, 0);
        });
      }
    }
    this.getcompany();
  }
  getPermissionDetails(unitId) {
    this.userPermissions.ModuleId =
      ConstantsService.PermissionMatrixModules.Incident;
    this.userPermissions.UserId = this.loggedInUserJSON.UserId;
    this.userPermissions.UnitId = unitId;
    const apiRequest = {
      Model: this.userPermissions,
    };
    this.commonService.getPermissionDetailsForUser(
      apiRequest,
      this.callbackMethodForgetPermissionDetails.bind(this),
    );
  }

  callbackMethodForgetPermissionDetails(response) {
    const permissions = response.Result;
    if (response.Result) {
      this.incidentPermission = permissions.IncidentPermission;
      if (
        !this.incidentPermission.INC_Add &&
        !this.incidentPermission.INC_Add_Unit &&
        !this.incidentPermission.INC_Admin &&
        !this.incidentPermission.INC_Admin_Unit
      ) {
        this.routesFlag.find(
          (s) =>
            s.routeName == IncidentConstantsService.RouteName.ReportIncident,
        ).isClickable = false;
      }
      if (
        !this.incidentPermission.INC_Add &&
        !this.incidentPermission.INC_Add_Unit &&
        !this.incidentPermission.INC_Admin &&
        !this.incidentPermission.INC_Admin_Unit
      ) {
        this.isUpdateAllowed = false;
      } else {
        this.isUpdateAllowed = true;
      }
      if (
        !this.incidentPermission.INC_Admin &&
        !this.incidentPermission.INC_Admin_Unit &&
        this.incidentId > 0
      ) {
        this.disableIncident = true;
      }
      if (
        this.incidentLoaded &&
        this.incidentRequest.IncidentRequest.RaisedBy.UserId ===
          this.loggedInUserJSON.UserId &&
        this.incidentRequest.IncidentRequest.CaseOwnerAppointment.UserId === 0
      ) {
        this.disableIncident = false;
      }
      if (
        (this.incidentRequest.IncidentRequest.Status === 'Cancelled' ||
          this.incidentRequest.IncidentRequest.Status === 'Deleted' ||
          this.incidentRequest.IncidentRequest.Status === 'Closed') &&
        !this.incidentPermission.INC_Admin &&
        !this.incidentPermission.INC_Admin_Unit
      ) {
        this.disableIncident = true;
      }
      if (
        this.incidentLoaded &&
        this.incidentRequest.IncidentRequest.CaseOwnerAppointment.UserId !==
          this.loggedInUserJSON.UserId &&
        !this.incidentPermission.INC_Owner &&
        !this.incidentPermission.INC_Owner_Unit &&
        !this.incidentPermission.INC_Admin &&
        !this.incidentPermission.INC_Admin_Unit
      ) {
        this.submitTORAction.Enabled = false;
        this.submitDraftReportAction.Enabled = false;
        this.submitInvestigationAction.Enabled = false;
      }
      if (
        this.incidentLoaded &&
        this.incidentRequest.IncidentRequest.RaisedBy &&
        this.incidentRequest.IncidentRequest.RaisedBy.UserId ===
          this.loggedInUserJSON.UserId &&
        (this.incidentRequest.IncidentRequest.Status === 'New' ||
          this.incidentRequest.IncidentRequest.Status === 'Draft')
      ) {
        this.disableIncident = false;
      }
    }
    this.selctedIncType = [];
    this.selectedincidentTypeId.forEach((element) => {
      this.selctedIncType.push(
        this.incidentDet.find((x) => x.IncidentTypeId === element).IncidentType,
      );
    });
    this.incidentRequest.IncidentRequest.SelectedIncidentTypeNames =
      this.selctedIncType;
    // this.incidentService.setUpdatedData(
    //   JSON.stringify(this.incidentRequest.IncidentRequest),
    //   "UpdateAction"
    // );
    // this.updateActionTrack = JSON.parse(
    //   this.incidentService.getUpdatedData("UpdateAction")
    // );
    this.baseService.showRootLoader = false;
    this.getAllModules();
  }

  // method to get company name
  getcompany() {
    this.baseService.showRootLoader = true;
    if (this.login) {
      const apiRequest = {
        Model: this.login,
      };
      this.observationService.getCompanyData(
        apiRequest,
        this.callbackMethodForgetCompanyData.bind(this),
      );
    }
  }

  // call back method of company name
  callbackMethodForgetCompanyData(response) {
    if (response === undefined) {
      this.serviceError();
    }
    if (response.Success) {
      this.company = response.Result;
    } else {
      this.baseService.showRootLoader = false;
    }
    if (
      response.Result.CompanyName === IncidentConstantsService.CompanyConst.QAMP
    ) {
      this.isDisplaySpilldetails = true;
    }
    if (
      this.company.CompanyName === IncidentConstantsService.CompanyConst.QAMP
    ) {
      this.selectedincidentCategoryId = [2];
    } else {
      this.selectedincidentCategoryId = [1];
    }
    if (response.Result.CompanyId === 0) {
      console.log('Company Id not found.');
      this.display = true;
    }
    this.getIncidentTypeByCompanyId();
  }
  getIsActiveUnit(unitId) {
    const apiRequestUnit = {
      Model: {
        UnitId: unitId,
      },
    };
    this.masterscreenService.getIsActiveUnit(
      apiRequestUnit,
      this.callbackMethodForgetIsActiveUnit.bind(this),
    );
  }

  callbackMethodForgetIsActiveUnit(response) {
    this.editEnabled = response.Result[0].IsActive;
  }

  // method to get the location
  getLocation() {
    if (this.login) {
      this.login.UnitId = this.selectedUnit.UnitId;
      const apiRequest = {
        Model: {
          ...this.login,
          GetActiveLocations: this.incidentId === 0 ? true : false,
        },
      };
      this.observationService.getLocationData(
        apiRequest,
        this.callbackMethodForGetLocationData.bind(this),
      );
    }
  }

  // call back method of get location
  callbackMethodForGetLocationData(response) {
    if (response === undefined) {
      this.serviceError();
    }
    if (response.Success) {
      this.locations = [];

      this.locationDet = response.Result;

      const locationDetails = response.Result;
      locationDetails.forEach((location) => {
        this.locations.push({
          label: location.LocationName,
          value: location.LocationId,
          InActive: location?.InActive,
        });
        if (location.LocationId === this.selectedLocation) {
          this.incidentRequest.IncidentRequest.LocationId = location.LocationId;
          this.isInactiveLocation = location?.InActive === true ? true : false;
          //this.disableIncident = (location?.InActive === true)? true:false;
          //this.incidentRequest.IncidentRequest.Location.LocationName = location.LocationName;
        }
      });
    }
    if (response.Errors !== null) {
      this.notificationsService.toastNotify(
        'error',
        'Error Message',
        'Location list is empty.',
      );
      this.hseErrorHandler.handleError(response.Errors);
    }
    this.baseService.showRootLoader = false;
  }
  getUserTypes() {
    this.observationService.getUserTypes(
      this.callbackMethodForgetUserTypes.bind(this),
    );
  }
  callbackMethodForgetUserTypes(response) {
    if (response.Error != null) {
      this.hseErrorHandler.handleError(response.Error);
    }
    if (response.Success) {
      this.userTypes = response.Result;
    }
  }
  getIncidentDataByIncidentId() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        IncidentRequestId: this.incidentId,
      },
    };
    this.incidentService.getIncidentDataByIncidentId(
      apiRequest,
      this.callbackMethodForgetIncidentDataByIncidentId.bind(this),
    );
  }
  callbackMethodForgetIncidentDataByIncidentId(response) {
    if (response) {
      // if (this.loggedInUserJSON.UserTypes.UserType ===
      //   ObservationConstantsService.RequestFor.Contractor && response.Result.RaisedBy.UserId != this.loggedInUserJSON.UserId
      // ) {
      //   this.notificationsService.toastNotify(
      //     "error",
      //     "Warning Message",
      //     "This Incident not raised by you, you don't have permission to view this record...!"
      //   );
      //   this.router.navigate([
      //     IncidentConstantsService.RoutingURLConstant.IncidentDashBoardURL
      //   ]);
      //   return ;
      // }
      this.incidentRequest.IncidentRequest = response.Result;
      this.getIsActiveUnit(this.incidentRequest.IncidentRequest.UnitId);

      this.isActive =
        this.incidentRequest.IncidentRequest.Status === 'New' ? true : false;
      this.incidentProcess.forEach((ip) => {
        ip.IncidentDate = moment(
          this.incidentRequest.IncidentRequest.IncidentDate,
        )
          .add('days', ip.IncidentProcessDateBuffer)
          .toDate();
      });
      this.unitTree.forEach((element) => {
        this.compareTreeNode(
          element,
          this.incidentRequest.IncidentRequest.UnitId,
        );
      });
      if (this.selectedUnit.UnitTypeId == 2) {
        this.isUnitEmployee = false;
      } else {
        this.isUnitEmployee = true;
      }
      this.getContractDetails(this.incidentRequest.IncidentRequest.UnitId);
      this.selectedContract = this.incidentRequest.IncidentRequest.Contract;
      this.getLocation();
      this.selectedLocation =
        this.incidentRequest.IncidentRequest.Location.LocationId;
      this.selectedInvestigation =
        this.incidentRequest.IncidentRequest.InvestigationId;
      this.incidentLoaded = true;
      this.getCaseOwnerDetails();
      this.getActionsByIncidentId();
      this.getPermissionDetails(this.incidentRequest.IncidentRequest.UnitId);

      this.incidentRequest.IncidentRequest.IncidentDate = new Date(
        moment(
          moment.utc(this.incidentRequest.IncidentRequest.IncidentDate).local(),
        ).format('MMM D, YYYY LT'),
      );
      this.incidentRequest.IncidentPEARList = response.Result.IncidentPEARList;
      this.incidentRequest.IncidentPEARList.forEach((incident) => {
        if (incident.Pear === 'People') {
          const tempPear = new PeopleIncident();
          tempPear.PeopleIncidentPear = incident.Pear;
          tempPear.PeopleIncidentSeverity = incident.Severity;
          this.PeopleIncident = tempPear;
          this.PeopleIncident.IncidentPeople =
            this.incidentService.getIncidentColorClass(
              tempPear.PeopleIncidentSeverity,
              tempPear.PeopleIncidentPear,
            );
          this.PeopleIncident.PeopleSelected = true;
        }
        if (incident.Pear === 'Assets') {
          const tempPear = new AssetsIncident();
          tempPear.AssetsIncidentPear = incident.Pear;
          tempPear.AssetsIncidentSeverity = incident.Severity;
          this.AssetsIncident = tempPear;
          this.AssetsIncident.IncidentAssets =
            this.incidentService.getIncidentColorClass(
              tempPear.AssetsIncidentSeverity,
              tempPear.AssetsIncidentPear,
            );
          this.AssetsIncident.AssetsSelected = true;
        }
        if (incident.Pear === 'Environment') {
          const tempPear = new EnvironmentIncident();
          tempPear.EnvironmentIncidentPear = incident.Pear;
          tempPear.EnvironmentIncidentSeverity = incident.Severity;
          this.EnvironmentIncident = tempPear;
          this.EnvironmentIncident.IncidentEnvironment =
            this.incidentService.getIncidentColorClass(
              tempPear.EnvironmentIncidentSeverity,
              tempPear.EnvironmentIncidentPear,
            );
          this.EnvironmentIncident.EnvironmentSelected = true;
        }
        if (incident.Pear === 'Reputation') {
          const tempPear = new ReputationIncident();
          tempPear.ReputationIncidentPear = incident.Pear;
          tempPear.ReputationIncidentSeverity = incident.Severity;
          this.ReputationIncident = tempPear;
          this.ReputationIncident.IncidentReputation =
            this.incidentService.getIncidentColorClass(
              tempPear.ReputationIncidentSeverity,
              tempPear.ReputationIncidentPear,
            );
          this.ReputationIncident.ReputationSelected = true;
        }
        if (incident.Pear === 'NPT') {
          const tempPear = new NPTIncident();
          tempPear.NPTIncidentPear = incident.Pear;
          tempPear.NPTIncidentSeverity = incident.Severity;
          this.NPTIncident = tempPear;
          this.NPTIncident.IncidentNPT =
            this.incidentService.getIncidentColorClass(
              tempPear.NPTIncidentSeverity,
              tempPear.NPTIncidentPear,
            );
          this.NPTIncident.NPTSelected = true;
        }
      });
      response.Result.IncidentPotentialPEARList.forEach((incident) => {
        if (incident.IncidentPear === 'People') {
          const tempPear = new PeopleIncident();
          tempPear.PeopleIncidentPear = incident.IncidentPear;
          tempPear.PeopleIncidentSeverity = incident.IncidentSeverity;
          tempPear.PeopleIncidentLikelihood = incident.IncidentLikelihood;
          this.PotentialPeopleIncident = tempPear;
          this.PotentialPeopleIncident.PeopleSelected = true;
          tempPear.PeopleIncidentColor = this.incidentService.getIncidentColor(
            tempPear.PeopleIncidentSeverity,
            tempPear.PeopleIncidentLikelihood,
          );
        }
        if (incident.IncidentPear === 'Environment') {
          const tempEnvironmentPear = new EnvironmentIncident();
          tempEnvironmentPear.EnvironmentIncidentPear = incident.IncidentPear;
          tempEnvironmentPear.EnvironmentIncidentSeverity =
            incident.IncidentSeverity;
          tempEnvironmentPear.EnvironmentIncidentLikelihood =
            incident.IncidentLikelihood;
          this.PotentialEnvironmentIncident = tempEnvironmentPear;
          this.PotentialEnvironmentIncident.EnvironmentSelected = true;
          tempEnvironmentPear.EnvironmentIncidentColor =
            this.incidentService.getIncidentColor(
              tempEnvironmentPear.EnvironmentIncidentSeverity,
              tempEnvironmentPear.EnvironmentIncidentLikelihood,
            );
        }
        if (incident.IncidentPear === 'Assets') {
          const tempAssetsPear = new AssetsIncident();
          tempAssetsPear.AssetsIncidentPear = incident.IncidentPear;
          tempAssetsPear.AssetsIncidentSeverity = incident.IncidentSeverity;
          tempAssetsPear.AssetsIncidentLikelihood = incident.IncidentLikelihood;
          this.PotentialAssetsIncident = tempAssetsPear;
          this.PotentialAssetsIncident.AssetsSelected = true;
          tempAssetsPear.AssetsIncidentColor =
            this.incidentService.getIncidentColor(
              tempAssetsPear.AssetsIncidentSeverity,
              tempAssetsPear.AssetsIncidentLikelihood,
            );
        }
        if (incident.IncidentPear === 'Reputation') {
          const tempReputationPear = new ReputationIncident();
          tempReputationPear.ReputationIncidentPear = incident.IncidentPear;
          tempReputationPear.ReputationIncidentSeverity =
            incident.IncidentSeverity;
          tempReputationPear.ReputationIncidentLikelihood =
            incident.IncidentLikelihood;
          this.PotentialReputationIncident = tempReputationPear;
          this.PotentialReputationIncident.ReputationSelected = true;
          tempReputationPear.ReputationIncidentColor =
            this.incidentService.getIncidentColor(
              tempReputationPear.ReputationIncidentSeverity,
              tempReputationPear.ReputationIncidentLikelihood,
            );
        }
        if (incident.IncidentPear === 'NPT') {
          const tempNPTPear = new NPTIncident();
          tempNPTPear.NPTIncidentPear = incident.IncidentPear;
          tempNPTPear.NPTIncidentSeverity = incident.IncidentSeverity;
          tempNPTPear.NPTIncidentLikelihood = incident.IncidentLikelihood;
          this.PotentialNPTIncident = tempNPTPear;
          this.PotentialNPTIncident.NPTSelected = true;
          tempNPTPear.NPTIncidentColor = this.incidentService.getIncidentColor(
            tempNPTPear.NPTIncidentSeverity,
            tempNPTPear.NPTIncidentLikelihood,
          );
        }
      });
      this.isHighPotential =
        this.incidentRequest.IncidentRequest.IsHighPotential.toString();
      this.selectedUserEmp = response.Result.IncidentObserveBy;
      this.selectedGeneralManager = response.Result.CaseOwner;
      this.incidentRequest.IncidentRequest.CaseOwnerAppointment =
        response.Result.CaseOwner;
      this.incidentRequest.IncidentRequest.LocationId =
        response.Result.Location.LocationId;
      this.incidentRequest.IncidentRequest.IncidentDate = new Date(
        this.incidentRequest.IncidentRequest.IncidentDate,
      );
      if (
        this.incidentRequest.IncidentRequest.RaisedBy.UserId ===
        this.loggedInUserJSON.UserId
      ) {
        this.incidentPermission.INC_Author = true;
      }
      this.incidentFiles = [];
      if (response.Result.FileUrl.length > 0) {
        this.incidentFiles = response.Result.FileUrl;
      }
      this.selectedincidentTypeId =
        this.incidentRequest.IncidentRequest.SelectedIncidentTypeIds;
      this.incidentType.forEach((element) => {
        if (this.selectedincidentTypeId.includes(element.IncidentTypeId)) {
          element.Checked = true;
        } else {
          element.Checked = false;
        }
      });
      this.Button.showResetButton = false;
      this.selectedincidentCategoryId.forEach((incidentcategory) => {
        this.incidentCategory.forEach((incident) => {
          if (incidentcategory === incident.IncidentCategoryId) {
            incident.Checked = true;
          } else {
            incident.Checked = false;
          }
        });
      });
      if (this.showBackOffice === 'true') {
        this.showPotentialSection = true;
      } else {
        this.showPotentialSection = false;
      }
      this.selectedReporting = this.incidentRequest.IncidentRequest.ReportedTo;
      this.reportedToList.forEach((element) => {
        if (this.selectedReporting.includes(element.value)) {
          element.checked = true;
        } else {
          element.checked = false;
        }
      });

      this.selctedIncType = [];
      this.selectedincidentTypeId.forEach((element) => {
        this.selctedIncType.push(
          this.incidentDet.find((x) => x.IncidentTypeId === element)
            .IncidentType,
        );
      });
      this.incidentRequest.IncidentRequest.SelectedIncidentTypeNames =
        this.selctedIncType;
      this.incidentService.setUpdatedData(
        JSON.stringify(this.incidentRequest.IncidentRequest),
        'UpdateAction',
      );

      this.incidentIds = this.incidentService.getAllIncidentIds();
      if (this.incidentIds == null) {
        this.isNext = false;
        this.isPrevious = false;
      }
      let currentIndex: number = 0;
      if (this.incidentIds) {
        this.incidentIds.forEach((element, index) => {
          if (element === this.incidentId) {
            currentIndex = index;
            return;
          }
        });
        if (currentIndex === 0) {
          this.isPrevious = false;
        }
        if (currentIndex === this.incidentIds.length - 1) {
          this.isNext = false;
        }
      }
      const apiRequest = {
        Model: {
          IncidentRequestId: this.incidentId,
        },
      };
      this.incidentService.getIncidentRatings(
        apiRequest,
        this.callbackMethodForGetIncidentRatings.bind(this),
      );
    }
    this.baseService.showRootLoader = false;
  }
  compareTreeNode(node, selectedNode) {
    var isFound: boolean = false;
    this.unitList.forEach((element) => {
      if (element.UnitId === node.UnitId) {
        isFound = true;
      }
    });
    if (!isFound || !node.IsActive) {
      node.selectable = false;
      node.expanded = false;
    }
    if (node.ParentId !== 0) {
      node.expanded = false;
    }
    if (node.UnitId === selectedNode) {
      this.selectedUnit = node;
      this.expandParents(this.selectedUnit);
    }
    if (node.children && node.children.length > 0) {
      node.selectable = false;
      node.children.forEach((element) => {
        var isFound: boolean = false;
        this.unitList.forEach((unit) => {
          if (unit.UnitId === element.UnitId) {
            isFound = true;
          }
        });
        if (!isFound || !element.IsActive) {
          element.selectable = false;
          element.expanded = false;
        }
        if (element.ParentId !== 0) {
          element.expanded = false;
        }
        if (element.UnitId === selectedNode) {
          this.selectedUnit = element;
          this.expandParents(this.selectedUnit);
        }
        if (element.children && element.children.length > 0) {
          this.compareTreeNode(element, selectedNode);
        }
      });
    }
  }
  expandParents(node) {
    if (node.parent) {
      node.parent.expanded = true;
      this.expandParents(node.parent);
    }
  }
  getUsersOnSearch(event) {
    // this.userTypes.forEach(userType => {
    //   if (userType.UserType === 'Employee') {
    //     this.searchTexts.UserTypeId = userType.UserTypeId;
    //   }
    // });
    if (this.loggedInUserJSON) {
      if (typeof event === 'string' || event instanceof String) {
        this.searchTexts.FilterTexts = '';
      } else {
        this.searchTexts.FilterTexts = event.query;
      }
      this.searchTexts.UserTypeId = 0;
      this.searchTexts.CompanyId = 0;

      if (this.selectedUnit && this.selectedUnit.UnitId > 0) {
        this.searchTexts.UnitId = this.selectedUnit.UnitId;
        const apiRequest = {
          Model: this.searchTexts,
        };
        this.observationService.getSearchResultsForUsers(
          apiRequest,
          this.callbackMethodForGetSearchResultsForUsersData.bind(this),
        );
      } else {
        this.notificationsService.toastNotify(
          'error',
          'Error Message',
          'Please Select Unit and then try to find user.',
        );
      }
    }
  }
  // Shows error message when service is not available ( WebAPIs are not in running mode)
  serviceError() {
    this.hseErrorHandler.handleError(
      'Service (WebAPI) is not available or not in running mode',
    );
  }
  // call back method of employee on search
  callbackMethodForGetSearchResultsForUsersData(response) {
    if (response === undefined) {
      this.serviceError();
    }

    if (response.Success) {
      const filtered: any[] = [];
      for (let i = 0; i < response.Result.length; i++) {
        this.user = response.Result[i];
        if (
          this.user.FullName.toLowerCase().indexOf(
            this.searchTexts.FilterTexts.toLowerCase(),
          ) !== -1
        ) {
          filtered.push(this.user);
        }
      }
      this.userResults = filtered;
    }

    if (response.Errors !== null) {
      this.hseErrorHandler.handleError(response.Errors);
    }
  }
  // method to check the validation
  checkValidation() {
    this.baseService.showRootLoader = true;
    this.validate = true;
    //this.unitError = false;

    this.unitError = true;
    if (this.selectedUnit != undefined) {
      if (this.selectedUnit.UnitId) {
        this.unitError = false;
        this.validate = true;
      }
    }
    if (!this.selectedUserEmp) {
      this.isIncidentReportErrorMsg = true;
      this.validate = false;
    }
    if (!this.incidentRequest.IncidentRequest.ActivityTakingAtIncident) {
      this.isIncidenttakingErrorMsg = true;
      this.validate = false;
    }
    if (!this.incidentRequest.IncidentRequest.IncidentDate) {
      this.isIncidentDateErrorMsg = true;
      this.validate = false;
    }
    if (!this.incidentRequest.IncidentRequest.LocationId) {
      this.isLocationMsg = true;
      this.validate = false;
    }
    if (!this.incidentRequest.IncidentRequest.InitalFact) {
      this.isInitialKnownMsg = true;
      this.validate = false;
    }
    if (!this.incidentRequest.IncidentRequest.ShortDescription) {
      this.isShortDescriptionMsg = true;
      this.validate = false;
    }
    if (!this.incidentRequest.IncidentRequest.DetailDescription) {
      this.isDetailsDescriptionMsg = true;
      this.validate = false;
    }
    if (this.incidentRequest.IncidentRequest.Pear.trim() === '0') {
      this.isShowpearErrorMsg = true;
      this.validate = false;
    }
    if (
      this.incidentRequest.IncidentRequest.Severity === 0 ||
      this.incidentRequest.IncidentRequest.Severity.toString() === '0'
    ) {
      this.isSeverityErrorMsg = true;
      this.validate = false;
    }
    if (!this.incidentRequest.IncidentRequest.RationaleClassification) {
      this.isClassificationErrorMsg = true;
      this.validate = false;
    }
    if (!this.incidentRequest.IncidentRequest.ActionTaken) {
      this.isActiontakenMsg = true;
      this.validate = false;
    }
    if (!this.incidentRequest.IncidentRequest.ImmediateCause) {
      this.isCauseMsg = true;
      this.validate = false;
    }
    if (!this.selectedincidentTypeId.length) {
      this.incidentTypeErrorMsg = true;
      this.validate = false;
    }
    if (!this.selectedReporting.length) {
      this.reportingErrorMsg = true;
      this.validate = false;
    }
    if (!this.selectedGeneralManager.UserId) {
      this.isCaseOwnerMsg = true;
      this.validate = false;
    }
    //BOC Pritesh
    if (!this.isUnitEmployee && this.selectedContract == 0) {
      this.showContractValidation = true;
      this.validate = false;
    }
    if (!this.isUnitEmployee && this.selectedContract != 0) {
      this.showContractValidation = false;
    }
    //EOC Pritesh
    if (this.validate) {
      this.raiseIncident();
    } else {
      this.baseService.showRootLoader = false;
      this.notificationsService.toastNotify(
        'error',
        'Error Message',
        'Please fill all Mandatory fields.',
      );
    }
  }
  raiseIncident() {
    this.baseService.showRootLoader = true;
    this.incidentRequest.IncidentRequest.RaisedBy =
      this.loggedInUserJSON.UserId;

    this.incidentRequest.IncidentRequest.IncidentObserveBy.UserId =
      this.selectedUserEmp.UserId;
    if (this.selectedGeneralManager.UserId > 0) {
      this.incidentRequest.IncidentRequest.CaseOwnerAppointment.UserId =
        this.selectedGeneralManager.UserId;
    }
    this.incidentRequest.IncidentRequest.SelectedIncidentTypeIds =
      this.selectedincidentTypeId;
    this.incidentRequest.IncidentPEARList = [];
    this.incidentRequest.IncidentPotentialPEARList = [];
    if (this.isHighPotential === 'true') {
      this.incidentRequest.IncidentRequest.IsHighPotential = true;
    } else {
      this.incidentRequest.IncidentRequest.IsHighPotential = false;
    }
    this.incidentRequest.IncidentRequest.CompanyId =
      this.loggedInUserJSON.Company.CompanyId;
    this.incidentRequest.IncidentRequest.TimeZone = 'Asia/Muscat';

    if (this.PeopleIncident) {
      const tempPear = new IncidentPearDetails();
      tempPear.Pear = this.PeopleIncident.PeopleIncidentPear;
      tempPear.Severity = this.PeopleIncident.PeopleIncidentSeverity;
      this.incidentRequest.IncidentPEARList.push(tempPear);
    }
    if (this.EnvironmentIncident) {
      const tempEnvironmentPear = new IncidentPearDetails();
      tempEnvironmentPear.Pear =
        this.EnvironmentIncident.EnvironmentIncidentPear;
      tempEnvironmentPear.Severity =
        this.EnvironmentIncident.EnvironmentIncidentSeverity;
      this.incidentRequest.IncidentPEARList.push(tempEnvironmentPear);
    }
    if (this.AssetsIncident) {
      const tempAssetsPear = new IncidentPearDetails();
      tempAssetsPear.Pear = this.AssetsIncident.AssetsIncidentPear;
      tempAssetsPear.Severity = this.AssetsIncident.AssetsIncidentSeverity;
      this.incidentRequest.IncidentPEARList.push(tempAssetsPear);
    }
    if (this.ReputationIncident) {
      const tempReputationPear = new IncidentPearDetails();
      tempReputationPear.Pear = this.ReputationIncident.ReputationIncidentPear;
      tempReputationPear.Severity =
        this.ReputationIncident.ReputationIncidentSeverity;
      this.incidentRequest.IncidentPEARList.push(tempReputationPear);
    }
    if (this.NPTIncident) {
      const tempNPTPear = new IncidentPearDetails();
      tempNPTPear.Pear = this.NPTIncident.NPTIncidentPear;
      tempNPTPear.Severity = this.NPTIncident.NPTIncidentSeverity;
      this.incidentRequest.IncidentPEARList.push(tempNPTPear);
    }

    if (this.PotentialPeopleIncident) {
      const tempPear = new PearDetails();
      tempPear.IncidentPear = this.PotentialPeopleIncident.PeopleIncidentPear;
      tempPear.IncidentSeverity =
        this.PotentialPeopleIncident.PeopleIncidentSeverity;
      tempPear.IncidentLikelihood =
        this.PotentialPeopleIncident.PeopleIncidentLikelihood;
      this.incidentRequest.IncidentPotentialPEARList.push(tempPear);
    }
    if (this.PotentialEnvironmentIncident) {
      const tempEnvironmentPear = new PearDetails();
      tempEnvironmentPear.IncidentPear =
        this.PotentialEnvironmentIncident.EnvironmentIncidentPear;
      tempEnvironmentPear.IncidentSeverity =
        this.PotentialEnvironmentIncident.EnvironmentIncidentSeverity;
      tempEnvironmentPear.IncidentLikelihood =
        this.PotentialEnvironmentIncident.EnvironmentIncidentLikelihood;
      this.incidentRequest.IncidentPotentialPEARList.push(tempEnvironmentPear);
    }
    if (this.PotentialAssetsIncident) {
      const tempAssetsPear = new PearDetails();
      tempAssetsPear.IncidentPear =
        this.PotentialAssetsIncident.AssetsIncidentPear;
      tempAssetsPear.IncidentSeverity =
        this.PotentialAssetsIncident.AssetsIncidentSeverity;
      tempAssetsPear.IncidentLikelihood =
        this.PotentialAssetsIncident.AssetsIncidentLikelihood;
      this.incidentRequest.IncidentPotentialPEARList.push(tempAssetsPear);
    }
    if (this.PotentialReputationIncident) {
      const tempReputationPear = new PearDetails();
      tempReputationPear.IncidentPear =
        this.PotentialReputationIncident.ReputationIncidentPear;
      tempReputationPear.IncidentSeverity =
        this.PotentialReputationIncident.ReputationIncidentSeverity;
      tempReputationPear.IncidentLikelihood =
        this.PotentialReputationIncident.ReputationIncidentLikelihood;
      this.incidentRequest.IncidentPotentialPEARList.push(tempReputationPear);
    }
    if (this.PotentialNPTIncident) {
      const tempNPTPear = new PearDetails();
      tempNPTPear.IncidentPear = this.PotentialNPTIncident.NPTIncidentPear;
      tempNPTPear.IncidentSeverity =
        this.PotentialNPTIncident.NPTIncidentSeverity;
      tempNPTPear.IncidentLikelihood =
        this.PotentialNPTIncident.NPTIncidentLikelihood;
      this.incidentRequest.IncidentPotentialPEARList.push(tempNPTPear);
    }
    this.incidentRequest.IncidentRequest.UnitId = parseInt(
      this.selectedUnit.UnitId,
    );
    this.incidentRequest.IncidentRequest.UnitName = this.selectedUnit.UnitName;

    this.incidentRequest.IncidentRequest.Location.LocationName =
      this.locationDet.find(
        (x) => x.LocationId === this.selectedLocation,
      ).LocationName;

    this.selctedIncType = [];
    this.selectedincidentTypeId.forEach((element) => {
      this.selctedIncType.push(
        this.incidentDet.find((x) => x.IncidentTypeId === element).IncidentType,
      );
    });
    this.incidentRequest.IncidentRequest.SelectedIncidentTypeNames =
      this.selctedIncType;

    this.incidentRequest.IncidentRequest.InvestigationId =
      this.selectedInvestigation;
    this.incidentRequest.IncidentRequest.ReportedTo = this.selectedReporting;
    this.incidentRequest.IncidentRequest.IsDraft = false;
    const apiRequest = {
      Model: this.incidentRequest,
    };
    if (this.incidentId > 0) {
      apiRequest.Model.IncidentRequest.IncidentRequestId = this.incidentId;
      this.incidentService.updateIncident(
        apiRequest,
        this.callbackMethodForRaiseIncident.bind(this),
      );
    } else {
      this.incidentService.raiseIncident(
        apiRequest,
        this.callbackMethodForRaiseIncident.bind(this),
      );
    }
  }

  callbackMethodForRaiseIncident(response) {
    this.baseService.showRootLoader = false;
    if (response && response.Success) {
      // show success message
      this.incidentIdForCaseOwner = response.Result;
      this.isClosed = false;
      if (this.incidentId) {
        this.notificationsService.toastNotify(
          'success',
          'Success Message',
          'Incident details has been updated successfully',
        );
        this.insertDetails();
        this.submitSpecificationData();
        // this.incidentRequest.IncidentRequest.CaseOwnerAppointment= this.caseOwnerIncidentAction.caseOwner ;
        this.incidentRequest.IncidentRequest.CaseOwnerAppointment.FullName =
          this.selectedGeneralManager.FullName;
        this.incidentRequest.IncidentRequest.IncidentPEARList =
          this.incidentRequest.IncidentPEARList;
        this.incidentRequest.IncidentRequest.IncidentPotentialPEARList =
          this.incidentRequest.IncidentPotentialPEARList;
        if (this.incidentRequest.IncidentRequest.IncidentRequestId > 0) {
          this.updateActionTrack = JSON.parse(
            this.incidentService.getUpdatedData('UpdateAction'),
          );

          this.trackdetails(
            this.updateActionTrack,
            this.incidentRequest.IncidentRequest,
            'UpdateAction',
            false,
          );
        }
        if (this.incidentActionDetailsRequest.length > 0) {
          this.incidentActionDetailsRequest.forEach((element) => {
            element.UnitId = parseInt(this.selectedUnit);
          });
          this.checkValidationForCaseOwner();
        }
        this.insertdocuments();
      } else {
        this.notificationsService.toastNotify(
          'success',
          'Success Message',
          'Incident details has been added successfully',
        );
        this.raised = true;
        this.displayId =
          ObservationConstantsService.ObservationCardModuleConst.INC.concat(
            this.incidentIdForCaseOwner.toString(),
          );
        // this.addActionFromCaseOwner();
        this.submitSpecificationData();
        this.getCaseOwnerDetails();
        this.getActionsByIncidentId();
        //this.trackdetails();
        if (this.incidentActionDetailsRequest.length > 0) {
          this.incidentActionDetailsRequest.forEach((element) => {
            element.UnitId = parseInt(this.selectedUnit);
          });
          this.checkValidationForCaseOwner();
        }
        //this.uploadtoDMS();
      }
      this.router.navigate([
        IncidentConstantsService.RoutingURLConstant.IncidentDashBoardURL,
      ]);
      //this.alertFrom = "RaisedUpdated";
    }
    if (response.Errors !== null) {
      if (response.Errors[0].Type === 'System.ArgumentNullException') {
        this.notificationsService.toastNotify(
          'error',
          'Error Message',
          'File already exists',
        );
      }
    }
  }

  trackdetails(OldValue, NewValue, action, isNew) {
    //if (this.status1.StatusName === "Open") {
    //isNew = true;
    //OldValue = [];
    //}
    const columnNames = Object.getOwnPropertyNames(
      this.incidentRequest.IncidentRequest,
    );
    columnNames.forEach((element) => {
      if (OldValue.length === 0) {
        this.retVal = false;
        // OldValue = null;
      } else {
        this.retVal = this.commonService.isDataEqual(
          OldValue[element],
          NewValue[element],
        );
      }
      if (this.retVal === false) {
        switch (action) {
          case 'UpdateAction':
            if (element === 'FileUrl') {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              if (OldValue !== null) {
                for (var i = 0; i < OldValue[element].length; i++) {
                  this.url = OldValue.FileUrl[i].name;
                  var filename = this.url.substring(
                    this.url.lastIndexOf('/') + 1,
                  );
                  userLoginActivity.OldValue += filename + ',';
                }
              } else {
                userLoginActivity.OldValue = null;
              }
              for (
                var i = 0;
                i < this.incidentRequest.IncidentRequest[element].length;
                i++
              ) {
                this.url1 =
                  this.incidentRequest.IncidentRequest.FileUrl[i].name;
                var filename = this.url1.substring(
                  this.url1.lastIndexOf('/') + 1,
                );
                userLoginActivity.NewValue += filename + ',';
              }
              if (userLoginActivity.OldValue != userLoginActivity.NewValue) {
                this.userActivityList.push(userLoginActivity);
              }
            } else if (
              element === 'IncidentRequestId' ||
              element === 'TimeZone' ||
              element === 'NotificationBy' ||
              element === 'RaisedBy' ||
              element === 'IncidentObserveBy' ||
              element === 'PeopleInvolved'
            ) {
            } else if (element === 'ActivityTakingAtIncident') {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element],
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            } else if (element === 'DetailDescription') {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element],
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            } else if (element === 'InitalFact') {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element],
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            } else if (element === 'UnitName') {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element],
              );

              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                if (OldValue.UnitId != NewValue.UnitId) {
                  this.userActivityList.push(userLoginActivity);
                }
              }
            } else if (element === 'SpecificLocation') {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element],
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            } else if (element === 'IncidentDate') {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element],
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            } else if (element === 'Contract') {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = 'Contract Number';
              userLoginActivity.OldValue = OldValue[element];
              userLoginActivity.NewValue = NewValue[element];
              this.userActivityList.push(userLoginActivity);
            } else if (element === 'IsHighPotential') {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element],
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            } else if (element === 'IncidentPEARList') {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = 'Actual Incident Severity';
              this.severityMaster.forEach((observe) => {
                this.incidentRequest.IncidentRequest.IncidentPEARList.forEach(
                  (observeid) => {
                    if (
                      observeid.Pear == 'People' ||
                      observeid.Pear == 'Environment' ||
                      observeid.Pear == 'Assets' ||
                      observeid.Pear == 'Reputation' ||
                      observeid.Pear == 'NPT'
                    ) {
                      if (observe.Value == observeid.Severity) {
                        userLoginActivity.NewValue +=
                          observeid.Pear + ' : ' + observe.Name + ', ';
                      }
                    }
                  },
                );

                if (this.updateActionTrack) {
                  this.updateActionTrack['IncidentPEARList'].forEach(
                    (observeid) => {
                      if (
                        observeid.Pear == 'People' ||
                        observeid.Pear == 'Environment' ||
                        observeid.Pear == 'Assets' ||
                        observeid.Pear == 'Reputation' ||
                        observeid.Pear == 'NPT'
                      ) {
                        if (observe.Value == observeid.Severity) {
                          userLoginActivity.OldValue +=
                            observeid.Pear + ' : ' + observe.Name + ', ';
                        }
                      }
                    },
                  );
                } else {
                  userLoginActivity.OldValue = null;
                }
              });
              if (userLoginActivity.OldValue != userLoginActivity.NewValue) {
                this.userActivityList.push(userLoginActivity);
              }
            } else if (element === 'IncidentPotentialPEARList') {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = 'Potential Incident';
              this.severityMaster.forEach((observe) => {
                this.incidentRequest.IncidentRequest.IncidentPotentialPEARList.forEach(
                  (observeid) => {
                    if (
                      observeid.IncidentPear == 'People' ||
                      observeid.IncidentPear == 'Environment' ||
                      observeid.IncidentPear == 'Assets' ||
                      observeid.IncidentPear == 'Reputation' ||
                      observeid.IncidentPear == 'NPT'
                    ) {
                      if (observe.Value == observeid.IncidentSeverity) {
                        userLoginActivity.NewValue +=
                          observeid.IncidentPear +
                          ' : ' +
                          observe.Name +
                          ', ' +
                          observeid.IncidentLikelihood +
                          ', ';
                      }
                    }
                  },
                );

                if (this.updateActionTrack) {
                  this.updateActionTrack['IncidentPotentialPEARList'].forEach(
                    (observeid) => {
                      if (
                        observeid.IncidentPear == 'People' ||
                        observeid.IncidentPear == 'Environment' ||
                        observeid.IncidentPear == 'Assets' ||
                        observeid.IncidentPear == 'Reputation' ||
                        observeid.IncidentPear == 'NPT'
                      ) {
                        if (observe.Value == observeid.IncidentSeverity) {
                          userLoginActivity.OldValue +=
                            observeid.IncidentPear +
                            ' : ' +
                            observe.Name +
                            ', ' +
                            observeid.IncidentLikelihood +
                            ', ';
                        }
                      }
                    },
                  );
                } else {
                  userLoginActivity.OldValue = null;
                }
              });
              if (userLoginActivity.OldValue != userLoginActivity.NewValue) {
                this.userActivityList.push(userLoginActivity);
              }
            }
            //
            else if (element === 'SelectedIncidentTypeIds') {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element],
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = 'Incident Type';
                this.incidentType.forEach((observe) => {
                  NewValue[element].forEach((observeid) => {
                    if (observe.IncidentTypeId === observeid) {
                      userLoginActivity.NewValue += observe.IncidentType + ',';
                    }
                  });
                });
                this.incidentType.forEach((observe) => {
                  OldValue[element].forEach((observeid) => {
                    if (observe.IncidentTypeId === observeid) {
                      userLoginActivity.OldValue += observe.IncidentType + ',';
                    }
                  });
                });
                if (userLoginActivity.OldValue != userLoginActivity.NewValue) {
                  this.userActivityList.push(userLoginActivity);
                }

                //  userLoginActivity.NewValue = NewValue[element];
                //this.userActivityList.push(userLoginActivity);
              }
            } //else if (element === "ReportedTo") {
            //     this.retVal = this.commonService.isDataEqual(
            //      OldValue[element],
            //      NewValue[element]
            //    );
            //    if (this.retVal === false) {
            //      const userLoginActivity = new UserLogInActivity();
            //      userLoginActivity.FieldName = element;
            //      userLoginActivity.OldValue = isNew ? null :this.reportedToList.find(x=>x.value === OldValue[element]).label;
            //      userLoginActivity.NewValue = this.reportedToList.find(x=>x.value === NewValue[element]).label;
            //      this.userActivityList.push(userLoginActivity);
            //    }
            //  }
            else if (element === 'ReportedTo') {
              const userLoginActivity = new UserLogInActivity();
              userLoginActivity.FieldName = element;
              this.reportedToList.forEach((observe) => {
                this.selectedReporting.forEach((observeid) => {
                  if (observe.value === observeid) {
                    userLoginActivity.NewValue += observe.label + ',';
                  }
                });
                if (this.updateActionTrack) {
                  this.updateActionTrack['ReportedTo'].forEach((observeid) => {
                    if (observe.value === observeid) {
                      userLoginActivity.OldValue += observe.label + ',';
                    }
                  });
                } else {
                  userLoginActivity.OldValue = null;
                }
              });
              // if(userLoginActivity.OldValue != userLoginActivity.NewValue)
              //{
              this.userActivityList.push(userLoginActivity);
              //}
            } else if (element === 'RationaleClassification') {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element],
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            } else if (element === 'ActionTaken') {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element],
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            } else if (element === 'ImmediateCause') {
              this.retVal = this.commonService.isDataEqual(
                OldValue[element],
                NewValue[element],
              );
              if (this.retVal === false) {
                const userLoginActivity = new UserLogInActivity();
                userLoginActivity.FieldName = element;
                userLoginActivity.OldValue = isNew ? null : OldValue[element];
                userLoginActivity.NewValue = NewValue[element];
                this.userActivityList.push(userLoginActivity);
              }
            } else if (element === 'Location' || element === 'CaseOwner') {
              if (element === 'Location') {
                this.retVal = this.commonService.isDataEqual(
                  OldValue[element],
                  NewValue[element],
                );
                if (this.retVal === false) {
                  const userLoginActivity = new UserLogInActivity();
                  userLoginActivity.FieldName = element;
                  userLoginActivity.OldValue = OldValue
                    ? OldValue[element].LocationName
                    : null;
                  userLoginActivity.NewValue =
                    this.incidentRequest.IncidentRequest[element].LocationName;
                  if (
                    userLoginActivity.OldValue != userLoginActivity.NewValue
                  ) {
                    this.userActivityList.push(userLoginActivity);
                  }
                }
              }
              if (element === 'CaseOwner') {
                this.retVal = this.commonService.isDataEqual(
                  OldValue[element],
                  NewValue[element],
                );
                if (this.retVal === false) {
                  const userLoginActivity = new UserLogInActivity();
                  userLoginActivity.FieldName = element;
                  userLoginActivity.OldValue = OldValue
                    ? OldValue[element].FullName
                    : null;
                  userLoginActivity.NewValue =
                    this.incidentRequest.IncidentRequest[element].FullName;
                  if (
                    userLoginActivity.OldValue != userLoginActivity.NewValue
                  ) {
                    this.userActivityList.push(userLoginActivity);
                  }
                }
              }
            }
        }
      }
    });
    if (this.userActivityList.length > 0) {
      this.commonService.saveUserActivityDetails(
        this.incidentRequest.IncidentRequest.IncidentRequestId,
        new Date(),
        'Incident',
        this.loggedInUserJSON.UserId,
        this.userActivityList,
      );
    }
  }

  // isNew: boolean = false;
  // oldIncidentDataDetails;
  // trackdetails(OldValue, NewValue, action, isNew) {
  //   // if (!this.incidentId) {
  //   //   this.oldIncidentDataDetails = null;
  //   // } else {
  //   //   this.oldIncidentDataDetails = JSON.parse(
  //   //     this.baseService.getItemFromSession("IncidentRequest")
  //   //   );
  //   // }

  //   const columnNames = Object.getOwnPropertyNames(
  //     this.incidentRequest.IncidentRequest
  //   );
  //   columnNames.forEach(element => {
  //     if (this.incidentRequest.IncidentRequest[element] instanceof Array) {
  //       if (element === "FileUrl") {
  //         const userLoginActivity = new UserLogInActivity();
  //         userLoginActivity.FieldName = element;
  //         if (this.oldIncidentDataDetails !== null) {
  //           for (
  //             var i = 0;
  //             i < this.oldIncidentDataDetails[element].length;
  //             i++
  //           ) {
  //             this.url = this.oldIncidentDataDetails.FileUrl[i].name;
  //             var filename = this.url.substring(this.url.lastIndexOf("/") + 1);
  //             userLoginActivity.OldValue += filename + ",";
  //           }
  //         } else {
  //           userLoginActivity.OldValue = null;
  //         }
  //         for (
  //           var i = 0;
  //           i < this.incidentRequest.IncidentRequest[element].length;
  //           i++
  //         ) {
  //           this.url1 = this.incidentRequest.IncidentRequest.FileUrl[i].name;
  //           var filename = this.url1.substring(this.url1.lastIndexOf("/") + 1);
  //           userLoginActivity.NewValue += filename + ",";
  //         }
  //         this.userActivityList.push(userLoginActivity);
  //       }
  //     } else if (
  //       element === "IncidentRequestId" ||
  //       element === "TimeZone" ||
  //       element === "NotificationBy" ||
  //       element === "RaisedBy" ||
  //       element === "CaseOwnerAppointment" ||
  //       element === "IncidentObserveBy" ||
  //       element === "PeopleInvolved"
  //     ) {
  //     } else if (
  //       element === "Location" ||
  //       element === "CaseOwner" ||
  //       element === "Company"
  //     ) {
  //       if (element === "Location") {
  //         const userLoginActivity = new UserLogInActivity();
  //         userLoginActivity.FieldName = element;
  //         userLoginActivity.OldValue = this.oldIncidentDataDetails
  //           ? this.oldIncidentDataDetails[element].LocationName
  //           : null;
  //         userLoginActivity.NewValue = this.incidentRequest.IncidentRequest[
  //           element
  //         ].LocationName;
  //         this.userActivityList.push(userLoginActivity);
  //       }
  //       if (element === "CaseOwner") {
  //         const userLoginActivity = new UserLogInActivity();
  //         userLoginActivity.FieldName = element;
  //         userLoginActivity.OldValue = this.oldIncidentDataDetails
  //           ? this.oldIncidentDataDetails[element].FullName
  //           : null;
  //         userLoginActivity.NewValue = this.incidentRequest.IncidentRequest[
  //           element
  //         ].FullName;
  //         this.userActivityList.push(userLoginActivity);
  //       }
  //       if (element === "Company") {
  //         const userLoginActivity = new UserLogInActivity();
  //         userLoginActivity.FieldName = element;
  //         userLoginActivity.OldValue = this.oldIncidentDataDetails
  //           ? this.oldIncidentDataDetails[element].CompanyName
  //           : null;
  //         userLoginActivity.NewValue = this.incidentRequest.IncidentRequest[
  //           element
  //         ].CompanyName;
  //         this.userActivityList.push(userLoginActivity);
  //       }
  //     } else {
  //       if (this.oldIncidentDataDetails === null) {
  //         this.retVal = false;
  //         this.isNew = true;
  //       } else {
  //         this.retVal = this.commonService.isDataEqual(
  //           this.oldIncidentDataDetails[element],
  //           this.incidentRequest.IncidentRequest[element]
  //         );
  //       }
  //       if (this.retVal === false) {
  //         const userLoginActivity = new UserLogInActivity();
  //         userLoginActivity.FieldName = element;
  //         userLoginActivity.OldValue = this.oldIncidentDataDetails
  //           ? this.oldIncidentDataDetails[element]
  //           : null;
  //         userLoginActivity.NewValue = this.incidentRequest
  //           ? this.incidentRequest.IncidentRequest[element]
  //           : null;
  //         this.userActivityList.push(userLoginActivity);
  //       }
  //     }
  //   });
  //   this.commonService.saveUserActivityDetails(
  //     this.isNew
  //       ? this.incidentIdForCaseOwner
  //       : this.incidentRequest.IncidentRequest.IncidentRequestId,
  //     new Date(),
  //     "Incident",
  //     this.loggedInUserJSON.UserId,
  //     this.userActivityList
  //   );
  // }
  uploadtoDMS() {
    if (this.incidentRequest.IncidentRequest.FileUrl.length > 0) {
      this.incidentRequest.IncidentRequest.FileUrl.forEach((element) => {
        const tempFile = new FileAttachment();
        tempFile.content = element.content;
        tempFile.metadata = element.metadata;
        tempFile.name = element.name;
        tempFile.size = element.size;
        tempFile.type = element.type;
        this.fileAttachments.push(tempFile);
      });
      this.commonService.saveDocumentsToHeap(
        this.displayId,
        this.company.CompanyName,
        'Incident',
        false,
        this.fileAttachments,
      );
    }
  }

  //#region- get incident Type from configuration
  getIncidentTypeByCompanyId() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        CompanyId: 1,
      },
    };
    // Get all observation type data
    this.incidentService.getIncidentTypeByCompanyId(
      apiRequest,
      this.callbackMethodForGetIncidentTypeDetails.bind(this),
    );
  }

  /**
   * Callback method of observation type details.
   * @param response - response of request.
   */
  callbackMethodForGetIncidentTypeDetails(response) {
    this.incidentDet = response.Result;
    this.incidentType = [];
    if (response && response.Success) {
      this.incidentType = response.Result;
    } else {
      this.baseService.showRootLoader = false;
      this.baseService.processApiResponseError(response);
    }
    this.getIncidentCategoryByCompanyId();
  }

  //#region- get incident Type from configuration
  getIncidentCategoryByCompanyId() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        CompanyId: this.loggedInUserJSON.Company.CompanyId,
      },
    };
    // Get all observation type data
    this.incidentService.getIncidentCategoryByCompanyId(
      apiRequest,
      this.callbackMethodForGetIncidentCategoryDetails.bind(this),
    );
  }

  /**
   * Callback method of observation type details.
   * @param response - response of request.
   */
  callbackMethodForGetIncidentCategoryDetails(response) {
    if (response && response.Success) {
      this.incidentCategory = response.Result;
      response.Result.filter(function (incidentcategory) {
        incidentcategory.checked = true;
      });
    } else {
      this.baseService.showRootLoader = false;
      this.baseService.processApiResponseError(response);
    }
    this.getUserTypes();
    if (this.incidentId > 0) {
      this.getIncidentDataByIncidentId();
    } else {
      this.baseService.showRootLoader = false;
    }
  }
  reset() {
    this.selectedUserEmp = new User();
    this.selectedGeneralManager = new User();
    this.incidentRequest.IncidentRequest = new IncidentRequestPost();
    this.incidentRequest.IncidentRequest.IncidentObserveBy = new User();
    this.incidentRequest.IncidentRequest.CaseOwnerAppointment = new User();
    this.peopleInvolved = [];
    this.spilDetails = [];
    this.selectedincidentCategoryId.forEach((incidentcategory) => {
      this.incidentCategory.forEach((incident) => {
        if (incidentcategory === incident.IncidentCategoryId) {
          incident.Checked = false;
        }
      });
    });
    this.selectedincidentTypeId.forEach((incidenttype) => {
      this.incidentType.forEach((incident) => {
        if (incidenttype === incident.IncidentTypeId) {
          incident.Checked = false;
        }
      });
    });
    this.PeopleIncident = new PeopleIncident();
    this.AssetsIncident = new AssetsIncident();
    this.EnvironmentIncident = new EnvironmentIncident();
    this.ReputationIncident = new ReputationIncident();
    this.NPTIncident = new NPTIncident();
    this.PotentialPeopleIncident = new PeopleIncident();
    this.PotentialEnvironmentIncident = new EnvironmentIncident();
    this.PotentialAssetsIncident = new AssetsIncident();
    this.PotentialReputationIncident = new ReputationIncident();
    this.PotentialNPTIncident = new NPTIncident();
    this.isHighPotential = 'false';
    this.selectedincidentCategoryId = [];
    this.selectedincidentTypeId = [];
    this.addPeople();
    this.addspilDetails();
    this.incidet = null;
    this.incidentActionDetailsRequest.forEach((action) => {
      action.ActionOwner = null;
      action.selectedActionParty = null;
      action.selectedActionVerifier = null;
      action.Priority = 2;
      action.TargetDate = new Date();
    });
  }
  addPeople() {
    this.people = new PeopleInvolved();
    this.peopleInvolved.push(this.people);
  }
  removePeople(index) {
    if (index !== 0) {
      this.peopleInvolved.splice(index, 1);
    }
  }
  addspilDetails() {
    this.spilDetail = new SpilDetails();
    this.spilDetails.push(this.spilDetail);
  }
  removespilDetails(index) {
    if (index !== 0) {
      this.spilDetails.splice(index, 1);
    }
  }
  SubmitCheckedIncidentCategory(incidentCategory, event) {
    if (event.target.checked) {
      this.selectedincidentCategoryId.push(incidentCategory.IncidentCategoryId);
    } else {
      const index = this.selectedincidentCategoryId.indexOf(
        incidentCategory.IncidentCategoryId,
      );
      if (index > -1) {
        this.selectedincidentCategoryId.splice(index, 1);
      }
    }
  }

  SubmitCheckedIncidentType(incidentType, event) {
    if (event.target.checked) {
      this.selectedincidentTypeId.push(incidentType.IncidentTypeId);
    } else {
      const index = this.selectedincidentTypeId.indexOf(
        incidentType.IncidentTypeId,
      );
      if (index > -1) {
        this.selectedincidentTypeId.splice(index, 1);
      }
    }
  }
  getIncidentColorClass(selectedType, TypeOfCategory) {
    switch (selectedType) {
      case IncidentConstantsService.RiskType.Incident:
        switch (TypeOfCategory) {
          case 'People':
            this.PeopleIncident.IncidentPeople =
              this.incidentService.getIncidentColorClass(
                this.PeopleIncident.PeopleIncidentSeverity,
                this.PeopleIncident.PeopleIncidentPear,
              );
            this.PotentialPeopleIncident.PeopleIncidentSeverity =
              this.PeopleIncident.PeopleIncidentSeverity;
            break;
          case 'Assets':
            this.AssetsIncident.IncidentAssets =
              this.incidentService.getIncidentColorClass(
                this.AssetsIncident.AssetsIncidentSeverity,
                this.AssetsIncident.AssetsIncidentPear,
              );
            this.PotentialAssetsIncident.AssetsIncidentSeverity =
              this.AssetsIncident.AssetsIncidentSeverity;
            break;
          case 'Environment':
            this.EnvironmentIncident.IncidentEnvironment =
              this.incidentService.getIncidentColorClass(
                this.EnvironmentIncident.EnvironmentIncidentSeverity,
                this.EnvironmentIncident.EnvironmentIncidentPear,
              );
            this.PotentialEnvironmentIncident.EnvironmentIncidentSeverity =
              this.EnvironmentIncident.EnvironmentIncidentSeverity;
            break;
          case 'Reputation':
            this.ReputationIncident.IncidentReputation =
              this.incidentService.getIncidentColorClass(
                this.ReputationIncident.ReputationIncidentSeverity,
                this.ReputationIncident.ReputationIncidentPear,
              );
            this.PotentialReputationIncident.ReputationIncidentSeverity =
              this.ReputationIncident.ReputationIncidentSeverity;
            break;
          case 'NPT':
            this.NPTIncident.IncidentNPT =
              this.incidentService.getIncidentColorClass(
                this.NPTIncident.NPTIncidentSeverity,
                this.NPTIncident.NPTIncidentPear,
              );
            this.PotentialNPTIncident.NPTIncidentSeverity =
              this.NPTIncident.NPTIncidentSeverity;
            break;
        }
        if (
          this.PeopleIncident.PeopleIncidentSeverity >= 3 ||
          this.EnvironmentIncident.EnvironmentIncidentSeverity >= 3 ||
          this.AssetsIncident.AssetsIncidentSeverity >= 3 ||
          this.ReputationIncident.ReputationIncidentSeverity >= 3 ||
          this.NPTIncident.NPTIncidentSeverity >= 3
        ) {
          this.isHighPotential = 'true';
          this.disablePotential = true;
        } else {
          this.isHighPotential = 'false';
          this.disablePotential = false;
        }
        break;
    }
  }
  confirmResetForm() {
    this.isReset = true;
    this.alertType = ConstantsService.Confirm;
    this.confirmMessage =
      'You have clicked reset button. All information ' +
      'entered by you on this page will be lost. Do you want to reset the form?';
  }
  // call when you click on ok of msg popup
  onOkClickedForConfirmation() {
    switch (this.alertFrom) {
      case 'Close':
        this.closeIncidentForCaseOwner();
        break;
      case 'RaisedUpdated':
        this.router.navigate([
          IncidentConstantsService.RoutingURLConstant.IncidentDashBoardURL,
        ]);
        break;
      default:
        this.router.navigate([
          IncidentConstantsService.RoutingURLConstant.IncidentDashBoardURL,
        ]);
        break;
    }
    this.alertType = null;
    this.errorDetails = null;
    this.successDetails = null;
    this.warningMessage = null;
  }
  onNoClickedForConfirmation() {
    this.alertType = null;
    this.confirmMessage = null;
    this.warningMessage = null;
  }
  saveLocation() {
    this.baseService.setItemInSession(
      'IncidentLocation' + this.loggedInUserJSON.Company.CompanyName,
      this.selectedLocation,
    );
    this.locations.forEach((location) => {
      if (location.value === this.selectedLocation) {
        this.incidentRequest.IncidentRequest.LocationId = location.value;
        this.isInactiveLocation = location?.InActive === true ? true : false;
      }
    });
  }
  downloadPDF() {
    this.notificationsService.toastNotify(
      'info',
      'Information Message',
      'Download is in Progress!',
    );
    const apiRequest = {
      Model: {
        ProcessName: 'Incident',
        SourceId: this.incidentId,
      },
    };
    this.incidentService.downloadPDF(
      apiRequest,
      this.callbackMethodForDownloadPDF.bind(this),
    );
  }

  callbackMethodForDownloadPDF(response) {
    if (response) {
      //Here assign the Byte array returned from API to data variable
      var fileDownLoadName = 'pdf_incidentrequest' + this.incidentId + '.pdf'; //Here we can assign name of the document
      FileUtility.downloadPDF(response, fileDownLoadName);
    }
  }
  isNew: boolean = false;
  oldIncidentDataDetails;
  getIncidentPotentialColor(selectedType, TypeOfCategory) {
    switch (selectedType) {
      case IncidentConstantsService.IncidentType.Residual:
        switch (TypeOfCategory) {
          case 'People':
            this.PotentialPeopleIncident.PeopleIncidentColor =
              this.incidentService.getIncidentColor(
                this.PotentialPeopleIncident.PeopleIncidentSeverity,
                this.PotentialPeopleIncident.PeopleIncidentLikelihood,
              );
            break;
          case 'Assets':
            this.PotentialAssetsIncident.AssetsIncidentColor =
              this.incidentService.getIncidentColor(
                this.PotentialAssetsIncident.AssetsIncidentSeverity,
                this.PotentialAssetsIncident.AssetsIncidentLikelihood,
              );
            break;
          case 'Environment':
            this.PotentialEnvironmentIncident.EnvironmentIncidentColor =
              this.incidentService.getIncidentColor(
                this.PotentialEnvironmentIncident.EnvironmentIncidentSeverity,
                this.PotentialEnvironmentIncident.EnvironmentIncidentLikelihood,
              );
            break;
          case 'Reputation':
            this.PotentialReputationIncident.ReputationIncidentColor =
              this.incidentService.getIncidentColor(
                this.PotentialReputationIncident.ReputationIncidentSeverity,
                this.PotentialReputationIncident.ReputationIncidentLikelihood,
              );
            break;
          case 'NPT':
            this.PotentialNPTIncident.NPTIncidentColor =
              this.incidentService.getIncidentColor(
                this.PotentialNPTIncident.NPTIncidentSeverity,
                this.PotentialNPTIncident.NPTIncidentLikelihood,
              );
            break;
        }
        break;
      case IncidentConstantsService.IncidentType.Potential:
        this.potentialIncidentColor = this.incidentService.getIncidentColor(
          this.incidentRequest.IncidentRequest.ResidualIncidentSeverity,
          this.incidentRequest.IncidentRequest.ResidualIncidentLikelihood,
        );
        break;
    }
  }
  // To get id of selected action party
  selectActionParty(event, index: number) {
    if (!event.UserId) {
      this.incidentActionDetailsRequest[index].selectedActionParty.UserId = 0;
    } else {
      this.incidentActionDetailsRequest[index].ShowActionPartyErrorMessage =
        false;
    }
  }
  // To get id of selected action owner
  selectActionOwner(event, index: number) {
    if (!event.UserId) {
      this.incidentActionDetailsRequest[index].ActionOwner.UserId = 0;
    } else {
      this.incidentActionDetailsRequest[index].selectedActionParty = new User();
      // this.incidentActionDetailsRequest[index].selectedActionParty = {
      //   UserId: event.UserId,
      //   FullName: event.FullName,
      //   Email: event.Email,
      //   FirstName: event.FirstName,
      //   LastName: event.LastName,
      //   UserTypeId: event.UserTypeId,
      //   UserTypes: event.UserTypes,
      //   ContactNumber: event.ContactNumber,
      //   Designation: event.Designation,
      //   DepartmentName: event.DepartmentName,
      //   UserTypeName: event.userTypeName,
      //   ContractNumber: event.ContractNumber,
      // };
      this.incidentActionDetailsRequest[index].ShowActionOwnerErrorMessage =
        false;
    }
  }
  selectActionVerifier(event, index: number) {
    if (!event.UserId) {
      this.incidentActionDetailsRequest[index].selectedActionVerifier.UserId =
        0;
    } else {
      this.incidentActionDetailsRequest[index].ShowActionVerifierErrorMessage =
        false;
    }
  }
  removeActionFromActionList(index) {
    if (this.incidentActionDetailsRequest.length > 1) {
      this.incidentActionDetailsRequest.splice(index, 1);
    }
  }
  addAction() {
    this.actionPost = new IncidentActionDetails();
    this.incidentActionDetailsRequest.push(this.actionPost);
    this.actionPost.SelectedAction = true;
  }
  insertDetails() {
    // this.caseOwnerActionId = document.CaseOwnerActionId;
    if (this.caseOwnerActionId === 0) {
      if (this.caseOwnerDetails.length !== 3) {
        this.caseOwnerDetails.push(this.submitTORAction);
        this.caseOwnerDetails.push(this.submitDraftReportAction);
        this.caseOwnerDetails.push(this.submitInvestigationAction);
      }
    }
  }
  callbackMethodForSaveCloseIncident(response) {
    if (response.Success) {
      if (this.raised === false) {
        this.getCaseOwnerDetails();
        this.getActionsByIncidentId();
      }
    }
  }
  addActionFromCaseOwner() {
    this.actionPost = new IncidentActionDetails();
    this.incidentActionDetailsRequest.push(this.actionPost);
    for (var i = 0; i < this.incidentActionDetailsRequest.length; i++) {
      this.incidentActionDetailsRequest[i].Action = 'TOR';
      this.incidentActionDetailsRequest[i].TargetDate = this.torDate;
      this.incidentActionDetailsRequest[i].ActionOwner =
        this.selectedGeneralManager;
      this.incidentActionDetailsRequest[i].selectedActionParty =
        this.selectedGeneralManager;
      this.incidentActionDetailsRequest[i].Priority = 2;
      this.incidentActionDetailsRequest[i].UnitId = parseInt(this.selectedUnit);
    }
    this.actionPost = new IncidentActionDetails();
    this.incidentActionDetailsRequest.push(this.actionPost);
    for (var i = 1; i < this.incidentActionDetailsRequest.length; i++) {
      this.incidentActionDetailsRequest[i].Action = 'Draft Report';
      this.incidentActionDetailsRequest[i].TargetDate = this.draftDate;
      this.incidentActionDetailsRequest[i].ActionOwner =
        this.selectedGeneralManager;
      this.incidentActionDetailsRequest[i].selectedActionParty =
        this.selectedGeneralManager;
      this.incidentActionDetailsRequest[i].Priority = 2;
      this.incidentActionDetailsRequest[i].UnitId = parseInt(this.selectedUnit);
    }
    this.actionPost = new IncidentActionDetails();
    this.incidentActionDetailsRequest.push(this.actionPost);
    for (var i = 2; i < this.incidentActionDetailsRequest.length; i++) {
      this.incidentActionDetailsRequest[i].Action =
        'Final Investigation Report';
      this.incidentActionDetailsRequest[i].TargetDate = this.investigateDate;
      this.incidentActionDetailsRequest[i].ActionOwner =
        this.selectedGeneralManager;
      this.incidentActionDetailsRequest[i].selectedActionParty =
        this.selectedGeneralManager;
      this.incidentActionDetailsRequest[i].Priority = 2;
      this.incidentActionDetailsRequest[i].UnitId = parseInt(this.selectedUnit);
    }
    this.actionPost = new IncidentActionDetails();
    this.incidentActionDetailsRequest.push(this.actionPost);
    for (var i = 3; i < this.incidentActionDetailsRequest.length; i++) {
      this.incidentActionDetailsRequest[i].Action =
        'MOM Management Meeting Review';
      this.incidentActionDetailsRequest[i].TargetDate = this.momDate;
      this.incidentActionDetailsRequest[i].ActionOwner =
        this.selectedGeneralManager;
      this.incidentActionDetailsRequest[i].selectedActionParty =
        this.selectedGeneralManager;
      this.incidentActionDetailsRequest[i].Priority = 2;
      this.incidentActionDetailsRequest[i].UnitId = parseInt(this.selectedUnit);
    }
    if (this.incidentRequest.IncidentRequest.IncidentRequestId === 0) {
      this.saveActions();
    }
  }
  getCaseOwnerDetails() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        IncidentRequestId: this.incidentId,
      },
    };
    this.incidentService.getCaseOwnerSubmittedDetails(
      apiRequest,
      this.callbackMethodForgetCaseOwnerDetails.bind(this),
    );
  }
  callbackMethodForgetCaseOwnerDetails(response) {
    if (response.Result.length > 0) {
      this.caseOwnerDetails = response.Result;
      this.isEnabled = true;
      for (var i = 0; i < response.Result.length; i++) {
        if (
          response.Result[i].IncidentProcessName ===
          this.incidentProcess[i].IncidentProcessName
        ) {
          this.incidentProcess[i].CaseOwnerActionId =
            response.Result[i].CaseOwnerActionId;
          this.incidentProcess[i].SelectedMarkAction =
            response.Result[i].SelectedMarkAction;
          this.incidentProcess[i].IncidentDate = moment(
            moment.utc(response.Result[i].DueDate).local(),
          ).toDate();
          if (response.Result[i].FileUrl !== null) {
            this.incidentProcess[i].Files = response.Result[i].FileUrl;
            this.incidentProcess[i].FileUrl = response.Result[i].FileUrl;
          } else {
            this.incidentProcess[i].Files = [];
            this.incidentProcess[i].FileUrl = [];
          }
        }
      }
    } else {
      this.submitTORAction.Enabled = true;
      this.submitDraftReportAction.Enabled = false;
      this.submitInvestigationAction.Enabled = false;
    }
    this.baseService.showRootLoader = false;
  }
  getActionsByIncidentId() {
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        IncidentRequestId: this.incidentId,
      },
    };
    // Get all observation type data
    this.incidentService.getActionsByIncidentId(
      apiRequest,
      this.callbackMethodForgetActionsByIncidentId.bind(this),
    );
  }
  /**
   * Callback  method to get action details by observationId
   * @param response - response of request.
   */
  callbackMethodForgetActionsByIncidentId(response) {
    if (response && response.Success) {
      this.incidentActionDetailsRequest = response.Result;
      this.disableAction = true;
      if (this.incidentActionDetailsRequest.length > 0) {
        this.incidentActionDetailsRequest.forEach((action) => {
          action.TargetDate = moment(
            moment.utc(action.TargetDate).local(),
          ).toDate();
          if (action.Status === 'Open') {
            this.isShowDisabled = true;
          }
          if (action.Files !== null) {
            action.FilesPreview = action.Files;
            action.Files = action.Files;
          }
          //this.showDeleteButton = action.Status === 'Deleted' || action.Status === 'Cancelled' || action.Status === 'Done' || action.Status === 'Closed' ? true : false;
        });
      }
    }
    this.baseService.showRootLoader = false;
  }
  closeIncidentRequest() {
    this.notificationsService.toastNotify(
      'warn',
      'Warning Message',
      'Please ensure that lessons learned are documented',
    );
    // this.closeIncidentForCaseOwner();
    this.ratingdialog = true;
  }

  saveActions() {
    this.incidentAction.RaisedBy = this.loggedInUserJSON.UserId;
    this.incidentActionDetailsRequest.forEach((element) => {
      element.UnitId = this.selectedUnit.UnitId;
    });
    this.incidentAction.incidentActionDetailsRequest =
      this.incidentActionDetailsRequest;
    if (this.incidentId === 0) {
      this.incidentAction.SourceId = this.incidentIdForCaseOwner;
    } else {
      this.incidentAction.SourceId =
        this.incidentRequest.IncidentRequest.IncidentRequestId;
    }
    this.incidentAction.ProcessName = 'Incident';
    const apiRequest = {
      Model: this.incidentAction,
    };
    this.incidentService.saveActions(
      apiRequest,
      this.callbackMethodForSaveAction.bind(this),
    );
  }
  callbackMethodForSaveAction(response) {
    if (response.Success) {
      // this.alertType = ConstantsService.Success;
      // this.successDetails = 'Incident details has been updated successfully ';
    }
  }
  onBasicUpload(document, j, event) {
    if (event.target.checked) {
      this.processName = document;
      this.processIndex = j;
      event.srcElement.blur();
      this.alertType = ConstantsService.Confirm;
      this.confirmMessage = 'Do you want to mark this process as completed?';
    }
  }
  onYesClickedForConfirmation() {
    if (this.isReset) {
      this.reset();
      this.alertType = '';
      this.confirmMessage = '';
    } else {
      // this.insertDetails(this.processName, this.processIndex);
    }
  }
  closeIncidentForCaseOwner() {
    this.closureDetails = 'Incident Closed';
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        IncidentRequestId:
          this.incidentRequest.IncidentRequest.IncidentRequestId,
        ClosureRemarks: this.closureDetails,
      },
    };
    this.incidentService.closeRequestByIncidentRequestId(
      apiRequest,
      this.callbackToCloseIncidentRequestById.bind(this),
    );
  }
  callbackToCloseIncidentRequestById(response) {
    this.isClosed = false;
    this.baseService.showRootLoader = false;
    this.notificationsService.toastNotify(
      'success',
      'Success Message',
      'Incident Closed Successfully',
    );
    this.savePDF();
  }
  savePDF() {
    const apiRequest = {
      Model: {
        ProcessName: 'Incident',
        SourceId: this.incidentRequest.IncidentRequest.IncidentRequestId,
      },
    };
    this.incidentService.savePDF(
      apiRequest,
      this.callbackMethodForSavePDF.bind(this),
    );
  }
  callbackMethodForSavePDF(response) {
    this.ngOnInit();
  }
  onNoClick() {
    this.closeIncident = false;
  }
  checkValidationForCaseOwner() {
    this.validateAction = true;
    this.incidentActionDetailsRequest.forEach((action) => {
      if (action.ActionOwner.UserId === 0) {
        action.ShowActionOwnerErrorMessage = true;
        this.validateAction = false;
      }
      if (action.selectedActionParty.UserId === 0) {
        action.ShowActionPartyErrorMessage = true;
        this.validateAction = false;
      }
      if (action.Action === '') {
        action.ShowActionErrorMessage = true;
        this.validateAction = false;
      }
    });
    if (this.validateAction) {
      if (this.incidentRequest.IncidentRequest.IncidentRequestId > 0) {
        this.saveActions();
      }
    } else {
      this.baseService.showRootLoader = false;
      this.notificationsService.toastNotify(
        'error',
        'Error Message',
        'Please fill all Mandatory fields.',
      );
    }
  }
  displayImage(event, index) {
    this.showImage =
      event.type === IncidentConstantsService.EventType.mouseenter
        ? true
        : false;
    if (this.showImage) {
      this.selectedIndex = index;
    }
  }
  onPreviousClick() {
    this.isNext = true;
    this.incidentIndex = -1;
    this.disableIncident = false;
    this.incidentIds = this.incidentService.getAllIncidentIds();
    if (this.incidentIds !== null && this.incidentIds.length >= 0) {
      this.incidentIds.forEach((element, index) => {
        if (element == this.incidentId && index - 1 != null) {
          this.incidentIndex = index - 1;
          if (this.incidentIndex <= 0) {
            this.isPrevious = false;
          } else {
            this.isPrevious = true;
          }
          return;
        }
      });
    }
    this.incidentId = this.incidentIds[this.incidentIndex];
    if (this.incidentIndex > -1) {
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          IncidentRequestId: this.incidentId,
        },
      };
      this.incidentService.getIncidentDataByIncidentId(
        apiRequest,
        this.callbackMethodForgetIncidentDataByIncidentId.bind(this),
      );
      this.router.navigate(['incident/report-incident/' + this.incidentId]);
    }
  }

  onNextClick() {
    this.isPrevious = true;
    this.incidentIndex = -1;
    this.disableIncident = false;
    this.incidentIds = this.incidentService.getAllIncidentIds();
    if (this.incidentIds != null && this.incidentIds.length >= 0) {
      this.incidentIds.forEach((element, index) => {
        if (element == this.incidentId && index + 1 != null) {
          this.incidentIndex = index + 1;
          if (this.incidentIndex + 1 == this.incidentIds.length) {
            this.isNext = false;
          } else {
            this.isNext = true;
          }
          return;
        } else if (element.IncidentRequestId == this.incidentIds) {
          this.isNext = false;
        }
      });
    }

    this.incidentId = this.incidentIds[this.incidentIndex];

    if (this.incidentIndex > -1) {
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          IncidentRequestId: this.incidentId,
        },
      };
      this.incidentService.getIncidentDataByIncidentId(
        apiRequest,
        this.callbackMethodForgetIncidentDataByIncidentId.bind(this),
      );
      this.router.navigate(['incident/report-incident/' + this.incidentId]);
    }
  }
  callbackMethodForGetIncidentProcessDetails(response) {
    this.incidentProcess = response;
    for (var i = 0; i < this.incidentProcess.length; i++) {
      const newDueDateForST = new Date();
      newDueDateForST.setDate(
        this.incidentRequest.IncidentRequest.IncidentDate.getDate() +
          parseInt(this.incidentProcess[i].IncidentProcessDateBuffer),
      );
      this.incidentProcess[i].IncidentDate = newDueDateForST;
    }
  }
  insertdocuments() {
    // for (var i = 0; i < this.incidentProcess.length; i++) {
    this.caseOwnerIncidentAction.caseOwner = this.incidentProcess;
    this.caseOwnerIncidentAction.IncidentRequestId = this.incidentId;
    this.caseOwnerIncidentAction.UploadedBy = this.loggedInUserJSON.UserId;
    // }
    // this.caseOwnerIncidentAction.caseOwner = this.incidentPr
    const apiRequest = {
      Model: this.caseOwnerIncidentAction,
    };
    this.incidentService.saveCaseOwnerAction(
      apiRequest,
      this.callbackMethodForSaveCloseIncident.bind(this),
    );
  }
  getUsersByUsageType(event) {
    if (this.selectedUnit && this.selectedUnit.UnitId > 0) {
      this.searchTexts.FilterTexts = event.query;
      const apiRequest = {
        Model: {
          ModuleId: ConstantsService.PermissionMatrixModules.Incident,
          UnitId: parseInt(this.selectedUnit.UnitId),
        },
      };
      this.commonService.getUsersByUsageType(
        apiRequest,
        this.callbackMethodForGetUsersByUsageType.bind(this),
      );
    } else {
      this.notificationsService.toastNotify(
        'error',
        'Error Message',
        'Please Select Unit and then try to find user.',
      );
    }
  }
  callbackMethodForGetUsersByUsageType(response) {
    this.userResults = [];
    if (response.Success) {
      const filtered: any[] = [];
      for (let i = 0; i < response.Result.length; i++) {
        this.user = response.Result[i];
        if (
          this.user.FullName.toLowerCase().indexOf(
            this.searchTexts.FilterTexts.toLowerCase(),
          ) === 0
        ) {
          filtered.push(this.user);
        }
      }
      this.userResults = filtered;
    }
  }
  callbackMethodForGetInvestigationDetails(response) {
    this.investigationDetails = [];
    response.forEach((element) => {
      this.investigationDetails.push({
        label:
          element.InvestigationLevelId + '-' + element.InvestigationLevelName,
        value: element.InvestigationLevelId,
      });
    });
  }
  getTexts(color, Pear) {
    if (Pear === 'People') {
      if (color === 'incidentColorRed') {
        return 'High';
      } else if (color === 'incidentColorYellow') {
        return 'Medium';
      } else if (color === 'incidentColorBlue') {
        return 'Low';
      }
    } else if ('Environment') {
      if (color === 'incidentColorRed') {
        return 'High';
      } else if (color === 'incidentColorYellow') {
        return 'Medium';
      } else if (color === 'incidentColorBlue') {
        return 'Low';
      }
    } else if ('Assets') {
      if (color === 'incidentColorRed') {
        return 'High';
      } else if (color === 'incidentColorYellow') {
        return 'Medium';
      } else if (color === 'incidentColorBlue') {
        return 'Low';
      }
    } else if ('Reputation') {
      if (color === 'incidentColorRed') {
        return 'High';
      } else if (color === 'incidentColorYellow') {
        return 'Medium';
      } else if (color === 'incidentColorBlue') {
        return 'Low';
      }
    } else if ('NPT') {
      if (color === 'incidentColorRed') {
        return 'High';
      } else if (color === 'incidentColorYellow') {
        return 'Medium';
      } else if (color === 'incidentColorBlue') {
        return 'Low';
      }
    }
  }
  getTextClass(colorClass) {
    switch (colorClass) {
      case 'incidentColorBlue':
        return 'text-white';
      case 'incidentColorYellow':
        return 'text-black';
      case 'incidentColorRed':
        return 'text-white';
    }
  }
  getAllModules() {
    this.masterscreenService.getAllModules(
      null,
      this.callbackMethodForGetAllModules.bind(this),
    );
  }
  callbackMethodForGetAllModules(response) {
    if (response.Success) {
      this.moduleList = response.Result;
      this.moduleList.forEach((element) => {
        if (element.ModuleName === 'Incident') {
          this.moduleId = element.ModuleId;
        }
      });
    }
  }
  categoryCheckedEmittedValue(data) {
    this.categoryCheckedValueData = data;
  }
  submitSpecificationData() {
    this.specificationDetailsData.RuleId = this.categoryCheckedValueData;
    this.specificationDetailsData.SourceId = this.incidentId
      ? this.incidentId
      : this.incidentIdForCaseOwner;
    this.specificationDetailsData.ModuleId = this.moduleId;

    const apiRequest = {
      Model: this.specificationDetailsData,
    };
    this.observationService.submitSpecificationData(
      apiRequest,
      this.callbackMethodForSubmitSpecificationData.bind(this),
    );
  }

  callbackMethodForSubmitSpecificationData(response) {
    if (response.Success) {
    }
  }
  nodeSelected(event) {
    this.selectedUnit = event.node;
    if (this.selectedUnit.children && this.selectedUnit.children.length > 0) {
      this.selectedUnit.expanded = true;
    }
    this.getLocation();
    if (this.selectedUnit.UnitTypeId == 2) {
      this.isUnitEmployee = false;
    } else {
      this.isUnitEmployee = true;
      this.incidentRequest.IncidentRequest.Contract = 0;
    }
    this.getContractDetails(this.selectedUnit.UnitId);
    this.getPermissionDetails(this.selectedUnit.UnitId);
  }
  cancelAssigned(actionId, index) {
    this.cancelRecord = true;
    this.cancelActionId = actionId;
  }
  cancelAction(cancelActionId) {
    if (
      this.cancelActionId > 1 &&
      this.cancellationReason != '' &&
      this.cancellationReason != undefined &&
      this.cancellationReason != null
    ) {
      this.cancelRecord = true;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          ActionId: this.cancelActionId,
          CancellationReason: this.cancellationReason,
          UpdatedBy: this.loggedInUserJSON.UserId,
          StatusId: 0,
        },
      };
      this.observationService.cancelactiondetails(
        apiRequest,
        this.callbackMethodForCancelActionDetails.bind(this),
      );
    } else {
      this.showCancellationmsg = true;
    }
  }
  callbackMethodForCancelActionDetails(response) {
    this.baseService.showRootLoader = false;
    this.cancelRecord = false;
    this.cancellationReason = '';
    this.ngOnInit();
  }
  onCancel() {
    this.cancelRecord = false;
    this.cancellationReason = '';
  }
  deleteAssigned(actionId, index) {
    if (actionId === 0) {
      this.incidentActionDetailsRequest.splice(index, 1);
    } else {
      this.deleteRecord = true;
      this.deleteActionId = actionId;
    }
  }
  deleteAction(deleteActionId) {
    if (
      this.deleteActionId > 1 &&
      this.deletionReason != '' &&
      this.deletionReason != undefined &&
      this.deletionReason != null
    ) {
      this.deleteRecord = true;
      this.baseService.showRootLoader = true;
      const apiRequest = {
        Model: {
          ActionId: this.deleteActionId,
          DeletionReason: this.deletionReason,
          UpdatedBy: this.loggedInUserJSON.UserId,
          StatusId: 0,
        },
      };
      this.observationService.deleteactiondetails(
        apiRequest,
        this.callbackMethodForDeleteActionDetails.bind(this),
      );
    } else {
      this.showDeletionmsg = true;
    }
  }
  callbackMethodForDeleteActionDetails(response) {
    this.baseService.showRootLoader = false;
    this.deleteRecord = false;
    this.deletionReason = '';
    this.ngOnInit();
  }
  onCancelClick() {
    this.deleteRecord = false;
    this.deletionReason = '';
  }
  onInputFilesUpdated(files, type, index) {
    switch (type) {
      case 'IncidentDocument':
        this.incidentRequest.IncidentRequest.FileUrl = files;
        break;
      case 'TOR':
        for (let i = 0; i < this.incidentProcess.length; i++) {
          if (i === index) {
            if (type === 'TOR') {
              this.incidentProcess[index].FileUrl = files;
            }
          }
        }
        break;
      case 'Draft Report':
        for (let i = 0; i < this.incidentProcess.length; i++) {
          if (i === index) {
            if (type === 'Draft Report') {
              this.incidentProcess[index].FileUrl = files;
            }
          }
        }
        break;
      case 'Final Investigation Report':
        for (let i = 0; i < this.incidentProcess.length; i++) {
          if (i === index) {
            if (type === 'Final Investigation Report') {
              this.incidentProcess[index].FileUrl = files;
            }
          }
        }
        break;
      case 'MOM Management Meeting Review':
        for (let i = 0; i < this.incidentProcess.length; i++) {
          if (i === index) {
            if (type === 'MOM Management Meeting Review') {
              this.incidentProcess[index].FileUrl = files;
            }
          }
        }
        break;
      default:
        break;
    }
  }
  getRemarks(remark, type, index) {
    switch (type) {
      case 'ActivityTakingAtIncident':
        this.incidentRequest.IncidentRequest.ActivityTakingAtIncident = remark;
        break;
      case 'CancellationReason':
        this.cancellationReason = remark;
        break;
      case 'DeletionReason':
        this.deletionReason = remark;
        break;
      case 'InitialFact':
        this.incidentRequest.IncidentRequest.InitalFact = remark;
        break;
      case 'RationaleClassification':
        this.incidentRequest.IncidentRequest.RationaleClassification = remark;
        break;
      case 'ActionTaken':
        this.incidentRequest.IncidentRequest.ActionTaken = remark;
        break;
      case 'ImmediateCause':
        this.incidentRequest.IncidentRequest.ImmediateCause = remark;
        break;
      case 'Action':
        this.incidentActionDetailsRequest[index].Action = remark;
        break;
      case 'Description':
        this.incidentRequest.IncidentRequest.DetailDescription = remark;
        break;
      default:
        break;
    }
  }
  getOutput(event) {
    if (event) {
      this.disableIncident = false;
      //this.ngOnInit();
      this.router.navigate([
        IncidentConstantsService.RoutingURLConstant.IncidentDashBoardURL,
      ]);
    }
  }
  showActions(actionId, processId) {
    this.router.navigate([
      '/actiontracker/all-action-details',
      actionId,
      { processId: processId },
    ]);
  }
  checkDisable(processName) {
    let foundProcess = this.incidentProcess.filter((process) => {
      if (process.IncidentProcessName === processName) {
        return process;
      }
    });
    if (foundProcess.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  CloseIncidentWithRating() {
    if (this.ValidateIncidentClose()) {
      this.baseService.showRootLoader = true;
      this.raiseIncident();
      const apiRequest = {
        Model: {
          IncidentRequestId: this.incidentId,
          UserId: this.loggedInUserJSON.UserId,
          IncidentRating: this.incidentRating,
        },
      };
      this.incidentService.closeIncidentWithRating(
        apiRequest,
        this.callbackToCloseIncidentWithRating.bind(this),
      );
    } else {
      this.notificationsService.toastNotify(
        'error',
        'Error Message',
        'Please select values for all Incident Ratings',
      );
    }
  }

  callbackToCloseIncidentWithRating(response) {
    this.baseService.showRootLoader = false;
    this.notificationsService.toastNotify(
      'success',
      'Success Message',
      'Incident Closed Successfully',
    );
    this.ratingdialog = false;
    this.ngOnInit();
  }

  submitReportedTo(reportedTo, event) {
    if (event.target.checked) {
      this.selectedReporting.push(reportedTo.value);
    } else {
      const index = this.selectedReporting.indexOf(reportedTo.value);
      if (index > -1) {
        this.selectedReporting.splice(index, 1);
      }
    }
  }

  callbackMethodForGetIncidentRatings(response) {
    if (response.Success) {
      this.incidentRating = {
        PotentialAssessment: response.Result.PotentialAssessment.toString(),
        TermsOfReference: response.Result.TermsOfReference.toString(),
        FollowUpExecution: response.Result.FollowUpExecution.toString(),
        InvestigationQuality: response.Result.InvestigationQuality.toString(),
        FieldReview: response.Result.FieldReview.toString(),
        ManagementReview: response.Result.ManagementReview.toString(),
      };
    }
  }

  ValidateIncidentClose(): boolean {
    let valid = true;
    if (this.incidentRating.PotentialAssessment.toString() === '-1') {
      valid = false;
    }
    if (this.incidentRating.TermsOfReference.toString() === '-1') {
      valid = false;
    }
    if (this.incidentRating.FollowUpExecution.toString() === '-1') {
      valid = false;
    }
    if (this.incidentRating.InvestigationQuality.toString() === '-1') {
      valid = false;
    }
    if (this.incidentRating.FieldReview.toString() === '-1') {
      valid = false;
    }
    if (this.incidentRating.ManagementReview.toString() === '-1') {
      valid = false;
    }
    return valid;
  }

  saveAsDraft() {
    this.baseService.showRootLoader = true;
    this.validate = true;
    if (!this.selectedUserEmp) {
      this.isIncidentReportErrorMsg = true;
      this.validate = false;
    }
    if (!this.incidentRequest.IncidentRequest.ActivityTakingAtIncident) {
      this.isIncidenttakingErrorMsg = true;
      this.validate = false;
    }
    if (!this.incidentRequest.IncidentRequest.IncidentDate) {
      this.isIncidentDateErrorMsg = true;
      this.validate = false;
    }
    if (!this.incidentRequest.IncidentRequest.LocationId) {
      this.isLocationMsg = true;
      this.validate = false;
    }
    if (!this.incidentRequest.IncidentRequest.InitalFact) {
      this.isInitialKnownMsg = true;
      this.validate = false;
    }
    if (!this.incidentRequest.IncidentRequest.ShortDescription) {
      this.isShortDescriptionMsg = true;
      this.validate = false;
    }
    if (!this.incidentRequest.IncidentRequest.DetailDescription) {
      this.isDetailsDescriptionMsg = true;
      this.validate = false;
    }
    if (this.incidentRequest.IncidentRequest.Pear.trim() === '0') {
      this.isShowpearErrorMsg = true;
      this.validate = false;
    }
    if (
      this.incidentRequest.IncidentRequest.Severity === 0 ||
      this.incidentRequest.IncidentRequest.Severity.toString() === '0'
    ) {
      this.isSeverityErrorMsg = true;
      this.validate = false;
    }
    if (!this.incidentRequest.IncidentRequest.RationaleClassification) {
      this.isClassificationErrorMsg = true;
      this.validate = false;
    }
    if (!this.incidentRequest.IncidentRequest.ActionTaken) {
      this.isActiontakenMsg = true;
      this.validate = false;
    }
    if (!this.incidentRequest.IncidentRequest.ImmediateCause) {
      this.isCauseMsg = true;
      this.validate = false;
    }
    if (!this.selectedincidentTypeId.length) {
      this.incidentTypeErrorMsg = true;
      this.validate = false;
    }
    if (!this.selectedReporting.length) {
      this.reportingErrorMsg = true;
      this.validate = false;
    }
    if (!this.selectedGeneralManager.UserId) {
      this.isCaseOwnerMsg = true;
      this.validate = false;
    }
    //BOC Pritesh
    if (!this.isUnitEmployee && this.selectedContract == 0) {
      this.showContractValidation = true;
      this.validate = false;
    }
    if (!this.isUnitEmployee && this.selectedContract != 0) {
      this.showContractValidation = false;
    }
    //EOC Pritesh
    if (this.validate) {
      this.raiseIncident_draft();
    } else {
      this.baseService.showRootLoader = false;
      this.notificationsService.toastNotify(
        'error',
        'Error Message',
        'Please fill all Mandatory fields.',
      );
    }
  }

  raiseIncident_draft() {
    this.baseService.showRootLoader = true;
    this.incidentRequest.IncidentRequest.RaisedBy =
      this.loggedInUserJSON.UserId;
    this.incidentRequest.IncidentRequest.IncidentObserveBy.UserId =
      this.selectedUserEmp.UserId;
    if (this.selectedGeneralManager.UserId > 0) {
      this.incidentRequest.IncidentRequest.CaseOwnerAppointment.UserId =
        this.selectedGeneralManager.UserId;
    }
    this.incidentRequest.IncidentRequest.SelectedIncidentTypeIds =
      this.selectedincidentTypeId;
    this.incidentRequest.IncidentPEARList = [];
    this.incidentRequest.IncidentPotentialPEARList = [];
    if (this.isHighPotential === 'true') {
      this.incidentRequest.IncidentRequest.IsHighPotential = true;
    } else {
      this.incidentRequest.IncidentRequest.IsHighPotential = false;
    }
    this.incidentRequest.IncidentRequest.CompanyId =
      this.loggedInUserJSON.Company.CompanyId;
    this.incidentRequest.IncidentRequest.TimeZone = 'Asia/Muscat';

    if (this.PeopleIncident) {
      const tempPear = new IncidentPearDetails();
      tempPear.Pear = this.PeopleIncident.PeopleIncidentPear;
      tempPear.Severity = this.PeopleIncident.PeopleIncidentSeverity;
      this.incidentRequest.IncidentPEARList.push(tempPear);
    }
    if (this.EnvironmentIncident) {
      const tempEnvironmentPear = new IncidentPearDetails();
      tempEnvironmentPear.Pear =
        this.EnvironmentIncident.EnvironmentIncidentPear;
      tempEnvironmentPear.Severity =
        this.EnvironmentIncident.EnvironmentIncidentSeverity;
      this.incidentRequest.IncidentPEARList.push(tempEnvironmentPear);
    }
    if (this.AssetsIncident) {
      const tempAssetsPear = new IncidentPearDetails();
      tempAssetsPear.Pear = this.AssetsIncident.AssetsIncidentPear;
      tempAssetsPear.Severity = this.AssetsIncident.AssetsIncidentSeverity;
      this.incidentRequest.IncidentPEARList.push(tempAssetsPear);
    }
    if (this.ReputationIncident) {
      const tempReputationPear = new IncidentPearDetails();
      tempReputationPear.Pear = this.ReputationIncident.ReputationIncidentPear;
      tempReputationPear.Severity =
        this.ReputationIncident.ReputationIncidentSeverity;
      this.incidentRequest.IncidentPEARList.push(tempReputationPear);
    }
    if (this.NPTIncident) {
      const tempNPTPear = new IncidentPearDetails();
      tempNPTPear.Pear = this.NPTIncident.NPTIncidentPear;
      tempNPTPear.Severity = this.NPTIncident.NPTIncidentSeverity;
      this.incidentRequest.IncidentPEARList.push(tempNPTPear);
    }

    if (this.PotentialPeopleIncident) {
      const tempPear = new PearDetails();
      tempPear.IncidentPear = this.PotentialPeopleIncident.PeopleIncidentPear;
      tempPear.IncidentSeverity =
        this.PotentialPeopleIncident.PeopleIncidentSeverity;
      tempPear.IncidentLikelihood =
        this.PotentialPeopleIncident.PeopleIncidentLikelihood;
      this.incidentRequest.IncidentPotentialPEARList.push(tempPear);
    }
    if (this.PotentialEnvironmentIncident) {
      const tempEnvironmentPear = new PearDetails();
      tempEnvironmentPear.IncidentPear =
        this.PotentialEnvironmentIncident.EnvironmentIncidentPear;
      tempEnvironmentPear.IncidentSeverity =
        this.PotentialEnvironmentIncident.EnvironmentIncidentSeverity;
      tempEnvironmentPear.IncidentLikelihood =
        this.PotentialEnvironmentIncident.EnvironmentIncidentLikelihood;
      this.incidentRequest.IncidentPotentialPEARList.push(tempEnvironmentPear);
    }
    if (this.PotentialAssetsIncident) {
      const tempAssetsPear = new PearDetails();
      tempAssetsPear.IncidentPear =
        this.PotentialAssetsIncident.AssetsIncidentPear;
      tempAssetsPear.IncidentSeverity =
        this.PotentialAssetsIncident.AssetsIncidentSeverity;
      tempAssetsPear.IncidentLikelihood =
        this.PotentialAssetsIncident.AssetsIncidentLikelihood;
      this.incidentRequest.IncidentPotentialPEARList.push(tempAssetsPear);
    }
    if (this.PotentialReputationIncident) {
      const tempReputationPear = new PearDetails();
      tempReputationPear.IncidentPear =
        this.PotentialReputationIncident.ReputationIncidentPear;
      tempReputationPear.IncidentSeverity =
        this.PotentialReputationIncident.ReputationIncidentSeverity;
      tempReputationPear.IncidentLikelihood =
        this.PotentialReputationIncident.ReputationIncidentLikelihood;
      this.incidentRequest.IncidentPotentialPEARList.push(tempReputationPear);
    }
    if (this.PotentialNPTIncident) {
      const tempNPTPear = new PearDetails();
      tempNPTPear.IncidentPear = this.PotentialNPTIncident.NPTIncidentPear;
      tempNPTPear.IncidentSeverity =
        this.PotentialNPTIncident.NPTIncidentSeverity;
      tempNPTPear.IncidentLikelihood =
        this.PotentialNPTIncident.NPTIncidentLikelihood;
      this.incidentRequest.IncidentPotentialPEARList.push(tempNPTPear);
    }
    this.incidentRequest.IncidentRequest.UnitId = parseInt(
      this.selectedUnit.UnitId,
    );
    this.incidentRequest.IncidentRequest.InvestigationId =
      this.selectedInvestigation;
    this.incidentRequest.IncidentRequest.ReportedTo = this.selectedReporting;
    this.incidentRequest.IncidentRequest.IsDraft = true;
    const apiRequest = {
      Model: this.incidentRequest,
    };
    if (this.incidentId > 0) {
      apiRequest.Model.IncidentRequest.IncidentRequestId = this.incidentId;
      this.incidentService.updateIncident(
        apiRequest,
        this.callbackMethodForRaiseIncident.bind(this),
      );
    } else {
      this.incidentService.raiseIncident(
        apiRequest,
        this.callbackMethodForRaiseIncident.bind(this),
      );
    }
  }

  //BOC Pritesh
  ReportshowDialog() {
    this.ReportUserId = this.loggedInUserJSON.UserId;
    this.ReportModule = 'Incident';
    this.ReportRecordId =
      this.incidentRequest.IncidentRequest.IncidentRequestId;
    this.ReportProcessId = 0;
    this.dialogHeight = (window.innerHeight - 50).toString() + 'px';
    this.dialogWidth = window.innerWidth.toString() + 'px';
    this.ReportclosePopup = true;
  }
  ReportclosePopUp() {
    this.ReportclosePopup = false;
  }

  getContractDetails(unitId: number): void {
    const apiRequestUnit = {
      Model: {
        UnitId: unitId,
      },
    };
    this.PDService.getContractDetailsData(
      apiRequestUnit,
      this.callbackMethodForContractDetails.bind(this),
    );
  }

  callbackMethodForContractDetails(response) {
    this.contracts = [];
    this.unitContractDetails = response;
    let contractHolderId;
    response.forEach((contract) => {
      this.contracts.push({
        label: contract.ContractNumber,
        value: contract.UnitContractDetailsId,
      });
    });
  }

  checkHolder(event) {
    let contract;
    contract = this.unitContractDetails.find(
      (contract) => contract.UnitContractDetailsId === event.value,
    );
    if (contract.ContractHolderId && contract.ContractNumber != '') {
      this.isHasContractDetails = true;
    } else {
      this.isHasContractDetails = false;
    }
    this.incidentRequest.IncidentRequest.Contract = event.value;
    this.showContractValidation = false;
  }
  //EOC Pritesh

  downloadTemplate(files) {
    if (files == null || files.length == 0) {
      this.notificationsService.toastNotify(
        'error',
        'Error Message',
        'Template is Not Available.Kindly Contact Admin.',
      );
    } else {
      files.forEach((element) => {
        saveAs(element.FilePath);
      });
    }
  }
}
